import {
  Button,
  Flex,
  Input,
  Stack,
  useColorModeValue,
  Text,
  Grid,
  Table,
  Tbody,
  Th,
  Thead,
  Tr,
  Td,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  ModalFooter,
  ModalContent,
  useDisclosure,
  useToast,
  useBreakpointValue,
  Select,
  Tooltip,
  Radio,
  RadioGroup,
  Image,
  FormErrorMessage,
  Icon,
  Box,
  Textarea,
  Checkbox,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  IconButton,
} from '@chakra-ui/react';
import { EditIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { MdOutlineCancel, MdPublish, MdHistory } from 'react-icons/md';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { FaRegClone } from 'react-icons/fa';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import QRCode from 'qrcode.react';
import CardHeader from 'components/Card/CardHeader';
import { HSeparator } from 'components/Separator/Separator';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import {
  showTextFloor,
  showTextDoYouKnow,
  BOOKING_STATUS_CANCEL,
  PAYMENT_TYPE_PAID,
  PAYMENT_TYPE_LIABILITY,
  PAYMENT_TYPE_UNPAID,
} from 'variables/columnsData';
import { useBookingActions } from 'hooks/useBookingActions';
import { useNotification } from 'hooks/useNotification';
import { useHistory, useParams } from 'react-router-dom';
import { IoAdd, IoMail, IoPrintOutline } from 'react-icons/all';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Editor from 'components/Editor/Editor';
import { checkForbidden } from 'helpers/checkForbidden';
import { NumericFormat } from 'react-number-format';
import cancelLogo from '../../../assets/img/cancel.png';
import { Select as ReactSelect } from 'chakra-react-select';
import { ShowAllIcon } from 'components/Icons/Icons';
import { useRecoilState, useRecoilValue } from 'recoil';
import { selectedShowAtom, paymentMethodListAtom } from '../../../state/show';
import { CUSTOMER_DISPLAY_CHANNEL_NAME } from 'helpers/customerDisplayChannel';
import { isOfficialPriceChannelGroup } from 'helpers/helpers';
import CustomerDisplayPreview from './CustomerDisplayPreview';
import ReactDatePicker from 'react-datepicker';
import { setHours, setMinutes } from 'date-fns';

function qrTransactionStorageKey(bookingId) {
  return `qr_transaction_${bookingId}`;
}

// Shared by the Payments and Transactions tabs below: numbers rows in their
// original (creation) order, then shows the most recent first, capped at
// `limit` until expanded.
function numberedDescending(rows, expanded, limit) {
  return (rows || [])
    .map((row, index) => ({ ...row, __no: index + 1 }))
    .sort((a, b) => b.__no - a.__no)
    .slice(0, expanded ? undefined : limit);
}

function openPdfInNewTab(url) {
  if (navigator.pdfViewerEnabled !== false) return false;
  return window.open(url) !== null;
}

// Every iOS browser is WebKit and ignores <a download> on blob URLs: Safari
// opens the PDF in a new tab, Chrome and the Google app do nothing. iPadOS
// reports itself as a Mac, hence the touch check.
const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

export default function BookingDetail() {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.700', 'white');
  const { booking_id } = useParams();
  const [bookingDetail, setBookingDetail] = useState();
  const [bookerandguestInfo, setBookerandguestInfo] = useState({});
  const [editBooker, setEditBooker] = useState(false);
  const [isCreateSpecialRequest, setIsCreateSpecialRequest] = useState(true);
  const [isCreatePayment, setIsCreatePayment] = useState(true);
  const [isAddingPayment, setIsAddingPayment] = useState(false);
  const [editGuest, setEditGuest] = useState(false);
  const [editDoYouKnow, setEditDoYouKnow] = useState(false);
  const [editReferenceCode, setEditReferenceCode] = useState(false);
  const [actionReloadPage, setActionReloadPage] = useState();
  const bookingActions = useBookingActions();
  const notificationActions = useNotification();
  const listPaymentMethod = useRecoilValue(paymentMethodListAtom);
  const [listHistoryBooking, setListHistoryBooking] = useState([]);
  const [listHistoryBookingDetail, setListHistoryBookingDetail] = useState([]);
  const [listHistoryBookingPayment, setListHistoryBookingPayment] = useState([]);
  const [listEmailHistory, setListEmailHistory] = useState([]);
  const [selectedPaymentIDs, setSelectedPaymentIDs] = useState([]);
  const [receiptPdfUrl, setReceiptPdfUrl] = useState(null);
  const [isPrintingReceipt, setIsPrintingReceipt] = useState(false);
  const [eTicketPdf, setETicketPdf] = useState(null);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isShowPayment, setIsShowPayment] = useState(false);
  const [isDisplayExtend, setIsDisplayExtend] = useState(false);
  const [amountPayment, setAmountPayment] = useState();
  const [remainingAmount, setRemainingAmount] = useState();
  const [countries, setCountries] = useState([]);
  const [selectedShow, setSelectedShow] = useRecoilState(selectedShowAtom);
  const [itemsBookingPaymentRefund, setItemsBookingPaymentRefund] = useState(
    []
  );
  const [showAllRefund, setShowAllRefund] = useState(true);
  const [isPaymentsTableExpanded, setIsPaymentsTableExpanded] = useState(false);
  const [isTransactionsTableExpanded, setIsTransactionsTableExpanded] = useState(false);
  const [expandedTransactionRows, setExpandedTransactionRows] = useState({});
  const [isDisplayCloneIcon, setDisplayCloneIcon] = useState();
  const customerDisplayChannelRef = useRef(null);

  // Channel to the counter-facing Customer Display. Re-broadcasts the
  // booking code here too since this page can be reached directly
  // (bookmark, refresh), not only via BookingPayment.js's Proceed button.
  useEffect(() => {
    customerDisplayChannelRef.current = new BroadcastChannel(
      CUSTOMER_DISPLAY_CHANNEL_NAME
    );
    return () => customerDisplayChannelRef.current?.close();
  }, []);

  const PAYMENTS_TABLE_ROW_LIMIT = 4;
  const visiblePayments = useMemo(
    () => numberedDescending(bookingDetail?.booking_payment, isPaymentsTableExpanded, PAYMENTS_TABLE_ROW_LIMIT),
    [bookingDetail?.booking_payment, isPaymentsTableExpanded]
  );
  const visibleTransactions = useMemo(
    () => numberedDescending(bookingDetail?.booking_transaction, isTransactionsTableExpanded, PAYMENTS_TABLE_ROW_LIMIT),
    [bookingDetail?.booking_transaction, isTransactionsTableExpanded]
  );
  const BookingStatusCancel = BOOKING_STATUS_CANCEL;
  const PaymentTypePaid = PAYMENT_TYPE_PAID;
  const PaymentTypeLiability = PAYMENT_TYPE_LIABILITY;
  const PaymentTypeUnpaid = PAYMENT_TYPE_UNPAID;
  const FEStatusCancelWith = '1';
  const FEStatusCancelWithout = '2';
  const history = useHistory();
  const [listExtendTimes, setListExtendTimes] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };
  const [modeViewETicket, setViewETicket] = useState('');
  const chakraStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      p: 0,
      w: '20px',
    }),
    container: (provided, state) => ({
      ...provided,
      width: '100%',
      maxWidth: '100%',
    }),
  };
  const {
    isOpen: isOpenAddExtendBookingModal,
    onOpen: onOpenAddExtendBookingModal,
    onClose: onCloseAddExtendBookingModal,
  } = useDisclosure();
  const {
    isOpen: isOpenAddPaymentModal,
    onOpen: onOpenAddPaymentModal,
    onClose: onCloseAddPaymentModal,
  } = useDisclosure();
  const {
    isOpen: isOpenViewHistoryModal,
    onOpen: onOpenViewHistoryModal,
    onClose: onCloseViewHistoryModal,
  } = useDisclosure();
  const {
    isOpen: isOpenViewSeatHistoryModal,
    onOpen: onOpenViewSeatHistoryModal,
    onClose: onCloseViewSeatHistoryModal,
  } = useDisclosure();
  const {
    isOpen: isOpenViewPaymentHistoryModal,
    onOpen: onOpenViewPaymentHistoryModal,
    onClose: onCloseViewPaymentHistoryModal,
  } = useDisclosure();
  const {
    isOpen: isOpenPaymentReceiptModal,
    onOpen: onOpenPaymentReceiptModal,
    onClose: onClosePaymentReceiptModal,
  } = useDisclosure();
  const {
    isOpen: isOpenETicketModal,
    onOpen: onOpenETicketModal,
    onClose: onCloseETicketModal,
  } = useDisclosure();
  // On phones a 75vh iframe plus the modal's margins, header and footer
  // overflows the screen, so go full-screen and let the PDF fill the rest.
  // Chakra 1.x ignores responsive values for `size`, hence the hook.
  const isETicketFullScreen = useBreakpointValue({ base: true, md: false });
  const {
    isOpen: isOpenCancelBookingModal,
    onOpen: onOpenCancelBookingModal,
    onClose: onCloseCancelBookingModal,
  } = useDisclosure();
  const {
    isOpen: isOpenPendingTransactionModal,
    onOpen: onOpenPendingTransactionModal,
    onClose: onClosePendingTransactionModal,
  } = useDisclosure();
  const [isCheckingPendingTransaction, setIsCheckingPendingTransaction] = useState(false);
  const {
    isOpen: isOpenCreateTransactionModal,
    onOpen: onOpenCreateTransactionModal,
    onClose: onCloseCreateTransactionModal,
  } = useDisclosure();
  const {
    isOpen: isOpenQrTransactionModal,
    onOpen: onOpenQrTransactionModal,
    onClose: onCloseQrTransactionModal,
  } = useDisclosure();
  const [isCreatingTransaction, setIsCreatingTransaction] = useState(false);
  const [qrTransaction, setQrTransaction] = useState(null);
  const {
    isOpen: isOpenCancelTransactionModal,
    onOpen: onOpenCancelTransactionModal,
    onClose: onCloseCancelTransactionModal,
  } = useDisclosure();
  const [isCancellingTransaction, setIsCancellingTransaction] = useState(false);
  const {
    isOpen: isOpenPublishInvoiceModal,
    onOpen: onOpenPublishInvoiceModal,
    onClose: onClosePublishInvoiceModal,
  } = useDisclosure();
  const {
    isOpen: isOpenSendETicketModal,
    onOpen: onOpenSendETicketModal,
    onClose: onCloseSendETicketModal,
  } = useDisclosure();
  const {
    isOpen: isOpenViewEmailHistoryModal,
    onOpen: onOpenViewEmailHistoryModal,
    onClose: onCloseViewEmailHistoryModal,
  } = useDisclosure();
  const [paymentMethod, setPaymentMethod] = useState([]);
  const validationSchema = Yup.object().shape({
    note: Yup.string().required('This field is required'),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    setError,
    formState,
    reset,
    control,
    watch,
    setValue,
  } = useForm(formOptions);
  const { errors, isSubmitting } = formState;
  const validationSchemaAddPayment = Yup.object().shape({
    paymentMethod: Yup.string().required('This field is required'),
    amount: Yup.string().required('This field is required'),
  });
  const formAddPaymentOptions = {
    resolver: yupResolver(validationSchemaAddPayment),
  };
  const {
    register: registerAddPayment,
    handleSubmit: handleSubmitAddPayment,
    formState: { isSubmitting: isSubmittingAddPayment },
    reset: resetAddPayment,
    control: controlPayment,
    setValue: setValuePayment,
    watch: watchPayment,
  } = useForm(formAddPaymentOptions);
  const paymentMethodField = registerAddPayment('paymentMethod');
  // Before the select registers, it shows the first payment method
  const isCashAddPayment =
    parseInt(watchPayment('paymentMethod') ?? listPaymentMethod[0]?.id) === 1; // 1 = Pay by Cash
  const addPaymentAmount =
    parseInt(String(watchPayment('amount') ?? '').replace(/,/g, '')) || 0;
  const addPaymentReceived =
    parseInt(String(watchPayment('receivedAmount') ?? '').replace(/,/g, '')) || 0;
  // Received from Customer follows Amount; the cashier can only raise it
  function setAddPaymentAmount(amount) {
    setValuePayment('amount', amount);
    setValuePayment('receivedAmount', amount);
  }

  const validationSchemaCreateTransaction = Yup.object().shape({
    amount: Yup.string().required('This field is required'),
  });
  const formCreateTransactionOptions = {
    resolver: yupResolver(validationSchemaCreateTransaction),
  };
  const {
    register: registerCreateTransaction,
    handleSubmit: handleSubmitCreateTransaction,
    formState: { isSubmitting: isSubmittingCreateTransaction, errors: errorsCreateTransaction },
    reset: resetCreateTransaction,
    control: controlCreateTransaction,
    setError: setErrorCreateTransaction,
    setValue: setValueCreateTransaction,
  } = useForm(formCreateTransactionOptions);

  const validationSchemaAddExtendBooking = Yup.object().shape({
    validity: Yup.string().required('This field is required'),
  });
  const validationSchemaSendETicket = Yup.object().shape({
    email: Yup.string().required('This field is required').email(),
    emailCc: Yup.string(),
  });
  const formAddExtendBookingOptions = {
    resolver: yupResolver(validationSchemaAddExtendBooking),
  };
  const formETicket = {
    resolver: yupResolver(validationSchemaSendETicket),
  };
  const {
    register: registerAddExtendBooking,
    handleSubmit: handleSubmitAddExtendBooking,
    formState: {
      isSubmitting: isSubmittingExtendBooking,
      errors: errorsExtendBooking,
    },
    watch: watchAddExtendBooking,
    reset: resetAddExtendBooking,
    setError: setErrorAddExtendBooking,
    control: controlAddExtendBooking,
    setValue: setValueAddExtendBooking,
  } = useForm(formAddExtendBookingOptions);
  const validateTime = watchAddExtendBooking('validity');
  const validationSchemaCancelBooking = Yup.object().shape({
    noteCancel: Yup.string().required('This field is required'),
  });
  const formCancelBookingOptions = {
    resolver: yupResolver(validationSchemaCancelBooking),
  };
  const {
    register: registerCancelBooking,
    handleSubmit: handleSubmitCancelBooking,
    formState: {
      isSubmitting: isSubmittingCancelBooking,
      errors: errorsCancelBooking,
    },
    reset: resetCancelBooking,
    control: controlCancelBooking,
    watch: watchCancelBooking,
    setValue: setValueCancelBooking,
    setError: setErrorCancelBooking,
  } = useForm(formCancelBookingOptions);

  const {
    register: registerPublishInvoice,
    handleSubmit: handleSubmitPublishInvoice,
    reset: resetPublishInvoice,
    formState: { isSubmitting: isSubmittingPublish },
  } = useForm();
  const {
    register: registerSendETicket,
    handleSubmit: handleSubmitSendETicket,
    reset: resetSendETicket,
    control: controlSendETicket,
    formState: { isSubmitting: isSubmittingETicket },
  } = useForm(formETicket);
  const optionCancel = watchCancelBooking('optionCancel');

  useEffect(async () => {
    const {
      data: { data },
    } = await bookingActions.getListExtendTimes({
      status: 1,
    });
    setListExtendTimes(data);
    const {
      data: { data: listCountries },
    } = await bookingActions.getCountries();
    setCountries(listCountries);
  }, []);
  useEffect(async () => {
    await bookingActions.getListPaymentMethod({ status: 1 }, 0, '');
    setValueAddExtendBooking('validity', '');
  }, []);
  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };

  const formatNotesHTML = (html) => {
    if (!html) return '';
    const notes = html.split('<br/>').filter(note => note.trim());
    return notes.map(note => `<div style="display: flex; flex-direction: column; margin-bottom: 8px;">${note}</div>`).join('');
  };
  useEffect(async () => {
    const {
      data: { data: historyBooking },
    } = await bookingActions.getHistoriesBooking(booking_id);
    setListHistoryBooking(historyBooking);
  }, [actionReloadPage]);
  useEffect(() => {
    if (remainingAmount === 0) {
      setIsShowPayment(false);
    }
  }, [remainingAmount]);
  useEffect(() => {
    if (!bookingDetail?.code) return;
    customerDisplayChannelRef.current?.postMessage({
      type: 'booking-code',
      code: bookingDetail.code,
    });
  }, [bookingDetail?.code]);

  // Pushes the full ticket (seats, payment breakdown, balance, booker/
  // audience) to the Customer Display whenever booking data or payment
  // totals change — also covers opening this page directly.
  useEffect(() => {
    if (!bookingDetail?.booking_detail) return;
    const zoneName = bookingDetail?.zone?.name;
    const seats = bookingDetail.booking_detail.map((i) => ({
      seat_number: i.seat,
      floor: i.floor,
      zone: { id: bookingDetail?.zone?.id, name: zoneName },
    }));
    // B2B/agency channel groups have their own agreed rate plan Amount that
    // isn't meant to be shown to the guest — show the zone's Official Price
    // instead for those (Balance card without status/remaining).
    const showOfficialPriceOnDisplay = isOfficialPriceChannelGroup(
      bookingDetail?.unit?.channel?.channel_group_id
    );
    const paymentRows = bookingDetail.booking_detail.map((i) => {
      const baseProgram =
        i.voucher_code_id > 0
          ? i.voucher_code?.voucher?.name
          : i.rateplan_config?.rateplan?.program_applied;
      return {
        seatNumber: i.seat,
        programApplied: i.is_child === 1 ? `${baseProgram} - Child` : baseProgram,
        officialPrice: i.official_price,
        amount: showOfficialPriceOnDisplay ? i.official_price : i.amount,
      };
    });
    const officialTotal = bookingDetail.booking_detail.reduce(
      (acc, i) => acc + (i.official_price || 0),
      0
    );
    const total = showOfficialPriceOnDisplay ? officialTotal : (bookingDetail.total_amount || 0);
    const paid = amountPayment || 0;
    const remaining = remainingAmount ?? Math.max(0, total - paid);
    const balanceStatus =
      paid <= 0 ? 'UNPAID' : remaining <= 0 ? 'FULLY PAID' : 'PARTIALLY PAID';

    customerDisplayChannelRef.current?.postMessage({
      type: 'booking-detail-summary',
      data: {
        bookingCode: bookingDetail.code,
        showName: bookingDetail?.show_schedule_detail?.show_schedule?.show?.name,
        venueName: bookingDetail?.show_schedule_detail?.show_schedule?.venue?.name,
        venueAddress: bookingDetail?.show_schedule_detail?.show_schedule?.venue?.address,
        showDate: bookingDetail?.show_schedule_detail?.date
          ? moment(bookingDetail.show_schedule_detail.date).format('DD/MM/YYYY')
          : '',
        showTime: bookingDetail?.show_schedule_detail?.time?.slice(0, -3),
        adult: bookingDetail.adult,
        child: bookingDetail.child,
        zone: zoneName,
        floor: showTextFloor(bookingDetail.floor),
        expireAt: null,
        seats,
        paymentBreakdown: { rows: paymentRows, total },
        // Official-Price channel groups only show Total — no status badge,
        // no Paid, no Remaining (see BalanceCard in BookingCustomerDisplay.js).
        // Other channels are untouched, still getting the full breakdown.
        balance: showOfficialPriceOnDisplay
          ? { total }
          : { total, paid, remaining, status: balanceStatus },
        // Lets the Customer Display show a success/cancelled outcome ribbon
        // and auto-return to Welcome once this booking is fully resolved.
        status: bookingDetail.status,
        paymentType: bookingDetail.payment_type,
        booker: { name: bookingDetail.booker_name, email: bookingDetail.booker_email, phone: bookingDetail.booker_phone },
        audience: { name: bookingDetail.guest_name, email: bookingDetail.guest_email, phone: bookingDetail.guest_phone },
      },
    });
  }, [bookingDetail, amountPayment, remainingAmount]);
  useEffect(async () => {
    const {
      data: { data: bookingDetail },
    } = await bookingActions.getBookingDetail(booking_id);
    setBookingDetail(bookingDetail);
    setValueAddExtendBooking('validity', new Date(bookingDetail?.expire_at));
    const bookingPaymentRefundSlice = bookingDetail?.booking_refund
      ? bookingDetail?.booking_refund.slice(0, 4)
      : [];

    setItemsBookingPaymentRefund(bookingPaymentRefundSlice);
    //default value of cancel booking
    if (bookingDetail && bookingDetail?.status != BookingStatusCancel) {
      setValueCancelBooking('optionCancel', FEStatusCancelWithout);
      if (bookingDetail.booking_payment) {
        bookingDetail.booking_payment.map((i, index) => {
          setValueCancelBooking(
            `amountCancel[${index}]`,
            i.amount.toLocaleString('en-US')
          );
          setValueCancelBooking(
            `paymentMethodCancel[${index}]`,
            i.payment_method.toString()
          );
        });
      }
    }

    let totalPayment = 0;
    if (bookingDetail.booking_payment) {
      bookingDetail.booking_payment.map((i, _) => {
        totalPayment = totalPayment + parseInt(i.amount);
      });
    }
    setAmountPayment(totalPayment);
    const remaining = bookingDetail.total_amount - totalPayment;
    setAddPaymentAmount(remaining);
    setRemainingAmount(remaining);
    if (bookingDetail.status == 1 && bookingDetail.payment_type == 3 && remaining > 0) {
      setIsDisplayExtend(true);
    } else {
      setIsDisplayExtend(false);
    }
    if (
      (bookingDetail.payment_type === 3 &&
        totalPayment < parseInt(bookingDetail.total_amount)) ||
      (bookingDetail.payment_type === 2 && bookingDetail.status === 1)
    ) {
      setIsShowPayment(true);
    }
    setBookerandguestInfo({
      booker_name: bookingDetail?.booker_name,
      booker_email: bookingDetail?.booker_email,
      booker_address: bookingDetail?.booker_address,
      booker_address2: bookingDetail?.booker_address2,
      booker_city: bookingDetail?.booker_city,
      booker_code: bookingDetail?.booker_code,
      booker_country: bookingDetail?.booker_country,
      booker_phone: bookingDetail?.booker_phone,
      booker_company: bookingDetail?.booker_company,
      booker_notes: bookingDetail?.booker_notes,
      guest_name: bookingDetail?.guest_name,
      guest_address: bookingDetail?.guest_address,
      guest_address2: bookingDetail?.guest_address2,
      guest_city: bookingDetail?.guest_city,
      guest_code: bookingDetail?.guest_code,
      guest_country: bookingDetail?.guest_country,
      guest_email: bookingDetail?.guest_email,
      guest_phone: bookingDetail?.guest_phone,
      guest_company: bookingDetail?.guest_company,
      guest_note: bookingDetail?.guest_note,
      doyouknow: bookingDetail?.doyouknow || '',
      doyouknow_other: bookingDetail?.doyouknow_other || '',
      reference_code: bookingDetail?.reference_code || '',
    });

    //check display clone icon
    let dateShowDetail = moment(bookingDetail?.show_schedule_detail?.date);
    let monthShow = moment().month() + 1;
    let stringMonth = monthShow > 10 ? '' + monthShow : '0' + monthShow;
    let stringDate =
      moment().date() > 10 ? '' + moment().date() : '0' + moment().date();
    let currentDate = moment(
      moment().year() + '-' + stringMonth + '-' + stringDate
    );
    setDisplayCloneIcon(dateShowDetail.diff(currentDate) < 0 ? false : true);
  }, [actionReloadPage, booking_id]);
  useEffect(() => {
    if (bookingDetail?.status === 1) {
      setIsShowPayment(false);
    }
  }, [bookingDetail?.status]);
  function seatStatus(statusRow) {
    if (!bookingDetail) {
      return undefined; // Handle the case where bookingDetail is not provided
    }
    //statusRow : status của từng vé
    const {
      status: statusBooking,
      payment_type,
      show_schedule_detail,
    } = bookingDetail;
    const dateObject = new Date(show_schedule_detail?.date);
    if (statusBooking === 1 || statusBooking === 3) {
      if (payment_type === 1 || payment_type === 2) {
        const [hours, minutes, seconds] = show_schedule_detail?.time.split(':');
        dateObject.setHours(hours);
        dateObject.setMinutes(minutes);
        dateObject.setSeconds(seconds);

        const currentDate = new Date().getTime();
        if (dateObject.getTime() > currentDate || statusRow == 2) {
          switch (statusRow) {
            case 1:
              return 'Printed';
            case 2:
              return 'Occupied';
            default:
              if (payment_type === 2) {
                return 'Liability';
              } else {
                return 'Paid';
              }
          }
        } else {
          return 'No show';
        }
      } else if (payment_type === 3) {
        return 'Unpaid';
      }
    } else if (statusBooking === 2) {
      return 'Released';
    }
    return undefined; // Handle the case where none of the conditions are met
  }
  const handlePaymentMethodChange = (option) => {
    setPaymentMethod(option.target.value);
  };
  const handleLanguageChange = (option) => {
    if (option.target.value == '') {
      return;
    }
    viewETicket(option.target.value);
    setViewETicket(option.target.value);
  };

  function cloneBooking() {
    bookingActions
      .selectShow({
        id: parseInt(bookingDetail?.show_schedule_detail_id),
      })
      .then((res) => {
        if (res.status === 200) {
          setSelectedShow(res.data.data);
          history.push('/admin/booking/create/information');
        }
      });
  }
  function bookingStatus(status) {
    switch (status) {
      case 1:
        return 'Success';
      case 2:
        return 'Cancel';
      case 3:
        return 'Unpaid';
      default:
        break;
    }
  }
  function paymentType(pt) {
    switch (pt) {
      case PaymentTypePaid:
        return 'Paid';
      case PaymentTypeLiability:
        return 'Liability';
      case PaymentTypeUnpaid:
        return 'Unpaid';
      default:
        break;
    }
  }
  function goToPrintTheaterPass() {
    history.push(`/admin/booking/create/print-theater-pass/${booking_id}`);
  }
  function paymentMethodText(paymentMethod) {
    switch (paymentMethod) {
      case 1:
        return 'Pay by Cash';
      case 2:
        return 'Pay by CreditCard VCB';
      case 3:
        return 'Pay by CreditCard AGR';
      case 4:
        return 'Pay via Paypal';
      case 5:
        return 'Pay by Bank Transfer';
      case 6:
        return '[T] Test Payment deleted';
      case 7:
        return 'Complimentary';
      case 8:
        return 'Pay via OnePay';
      case 9:
        return 'Pay by CreditCard BIDV';
      case 10:
        return 'Pay by CreditCard VIETIN';
      default:
        break;
    }
  }

  function cancelledTypeText(type) {
    switch (type) {
      case 0:
        return 'Cancel without refund';
      case 1:
        return 'Cancel without charge';
      case 2:
        return 'Cancel with refund';
      case 3:
        return 'Cancel with charge';
      default:
        return 'Cancel by system due to Release Time';
    }
  }

  async function updateBookingInfoBookerandGuest(type) {
    const res = await bookingActions.updateBookingInfoGuestandBooker(
      bookerandguestInfo,
      booking_id
    );
    if (res.status === 200) {
      if (type === 'booker') {
        setEditBooker(false);
      } else if (type === 'guest') {
        setEditGuest(false);
      } else if (type === 'doyouknow') {
        setEditDoYouKnow(false);
      } else if (type === 'reference_code') {
        setEditReferenceCode(false);
      }
      setActionReloadPage(Math.random());
    }
  }
  async function viewETicket(value) {
    const part = value.split('_');
    const response = await bookingActions.getETicketPDF(
      { code: bookingDetail?.code, lang: part[0], type: part[1] },
      booking_id
    );
    // A blob URL drops the response's Content-Disposition, so the PDF
    // viewer's own download button would save it as the blob UUID. Preview
    // it in a modal and download through our own button using the BE name.
    const titleLabels = {
      Information: 'BOOKING INFORMATION',
      TheaterPass: 'THEATER PASS',
    };
    const fallbackPrefixes = {
      Information: 'LUNE-BOOKING-INFORMATION',
      TheaterPass: 'LUNE-THEATER-PASS',
    };
    const title = `${titleLabels[part[1]] || 'E-TICKET'} - ${bookingDetail?.code}`;
    let fileName = `${fallbackPrefixes[part[1]] || 'LUNE-ETICKET'}-${bookingDetail?.code}.pdf`;
    const contentDisposition = response.headers?.['content-disposition'];
    if (contentDisposition) {
      const match =
        contentDisposition.match(/filename\*=[^']*''([^;\n\r]+)/i) ||
        contentDisposition.match(/filename="?([^";]+)"?/i);
      if (match && match[1]) fileName = decodeURIComponent(match[1]);
    }
    if (eTicketPdf) URL.revokeObjectURL(eTicketPdf.url);
    const url = URL.createObjectURL(response.data);
    setETicketPdf({ url, title, fileName, blob: response.data });
    if (openPdfInNewTab(url)) {
      // Reset the select so picking the same file again reopens it
      setViewETicket('');
      return;
    }
    onOpenETicketModal();
  }
  async function downloadETicket() {
    if (isIOS) {
      // The share sheet's "Save to Files" keeps the BE file name.
      const file = new File([eTicketPdf.blob], eTicketPdf.fileName, {
        type: 'application/pdf',
      });
      if (!navigator.canShare?.({ files: [file] })) {
        toast({
          description: 'This browser cannot save the PDF. Please open the page in Safari.',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
        return;
      }
      try {
        await navigator.share({ files: [file] });
      } catch (error) {
        // AbortError means the user closed the share sheet
        if (error.name !== 'AbortError') {
          toast({
            description: 'Download failed',
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top-right',
          });
        }
      }
      return;
    }
    const link = document.createElement('a');
    link.href = eTicketPdf.url;
    link.setAttribute('download', eTicketPdf.fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  function closeETicketModal() {
    onCloseETicketModal();
    // Reset the select so picking the same file again reopens the preview
    setViewETicket('');
  }
  async function onSubmit({ note }) {
    try {
      if (isCreateSpecialRequest) {
        const res = await bookingActions.addSpecialRequest(
          {
            note,
          },
          booking_id
        );
        if (res.status === 200) {
          toast({
            description: `Add Special Request successful`,
            status: 'success',
            duration: 5000,
            isClosable: true,
            position: 'top-right',
          });
        }
        setActionReloadPage(Math.random());
      }

      onClose();
      reset();
    } catch (err) {
      setError('apiError', { message: err.response.data.meta.message });
    }
  }
  async function onSubmitAddPayment({ paymentMethod, amount, receivedAmount }) {
    // Prevent double-submit
    if (isAddingPayment) {
      return false;
    }

    const valAmount = amount.replace(/,/g, '');
    if (parseInt(valAmount) <= 0) {
      setError('amount', {
        message: 'Amount should be greater than 0',
      });
      return false;
    }
    let remaining = parseInt(bookingDetail.total_amount) - amountPayment;
    if (parseInt(valAmount) > parseInt(remaining)) {
      setError('amount', {
        message:
          'Amount should be equal to or less than ' +
          remaining.toLocaleString('en-US') +
          ' VND',
      });
      return false;
    }
    // Cash handed over by the customer, only for cash; empty = exactly Amount
    const valReceived =
      parseInt(paymentMethod) === 1
        ? parseInt(String(receivedAmount ?? '').replace(/,/g, '')) ||
          parseInt(valAmount)
        : 0;
    if (valReceived > 0 && valReceived < parseInt(valAmount)) {
      setError('receivedAmount', {
        message: 'Received amount should be equal to or greater than Amount',
      });
      return false;
    }

    setIsAddingPayment(true);
    try {
      const res = await bookingActions.addPayment(
        {
          payment_method: parseInt(paymentMethod),
          amount: parseInt(valAmount),
          received_amount: valReceived,
        },
        booking_id
      );

      if (res.status === 200) {
        toast({
          description: `Add Payment successful`,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
        setActionReloadPage(Math.random());
        onCloseAddPaymentModal();
        resetAddPayment();
        setError('apiError', {
          message: '',
        });
      }
    } catch (error) {
      toast({
        description: error?.response?.data?.meta?.message || 'Add Payment failed',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    } finally {
      setIsAddingPayment(false);
    }
  }
  async function onSubmitCreateTransaction({ amount }) {
    // Prevent double-submit
    if (isCreatingTransaction) {
      return false;
    }

    const valAmount = amount.replace(/,/g, '');
    if (parseInt(valAmount) <= 0) {
      setErrorCreateTransaction('amount', {
        message: 'Amount should be greater than 0',
      });
      return false;
    }
    if (parseInt(valAmount) > parseInt(remainingAmount)) {
      setErrorCreateTransaction('amount', {
        message:
          'Amount should be equal to or less than ' +
          remainingAmount.toLocaleString('en-US') +
          ' VND',
      });
      return false;
    }

    setIsCreatingTransaction(true);
    try {
      const res = await bookingActions.createTransaction(
        {
          amount: parseInt(valAmount),
          payment_method: 4,
        },
        booking_id
      );

      if (res.status === 200) {
        // Backend doesn't echo the amount back, keep the value the user
        // just submitted so the QR modal can display it.
        const qrData = { ...res.data.data, amount: valAmount };
        setQrTransaction(qrData);
        // Persisted so a refresh or tab close/reopen while this QR is still
        // pending can bring the modal back up instead of losing it silently.
        localStorage.setItem(qrTransactionStorageKey(booking_id), JSON.stringify(qrData));
        onCloseCreateTransactionModal();
        resetCreateTransaction();
        onOpenQrTransactionModal();
      }
    } catch (error) {
      toast({
        description:
          error?.response?.data?.meta?.message || 'Create Transaction failed',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    } finally {
      setIsCreatingTransaction(false);
    }
  }

  function closeQrTransactionModal() {
    onCloseQrTransactionModal();
    setQrTransaction(null);
    localStorage.removeItem(qrTransactionStorageKey(booking_id));
  }

  // Actively voids the transaction on the gateway (not just hiding the
  // modal) so the QR the guest is holding can no longer be paid.
  async function handleCancelTransaction() {
    if (isCancellingTransaction || !qrTransaction?.transaction_code) {
      return;
    }
    setIsCancellingTransaction(true);
    try {
      await bookingActions.cancelTransaction(booking_id, qrTransaction.transaction_code);
      onCloseCancelTransactionModal();
      closeQrTransactionModal();
      toast({
        description: 'Transaction cancelled',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
      setActionReloadPage(Math.random());
    } catch (error) {
      toast({
        description: error?.response?.data?.meta?.message || 'Cancel Transaction failed',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    } finally {
      setIsCancellingTransaction(false);
    }
  }

  // A QR transaction may still be pending when the page is refreshed or the
  // tab is closed and reopened. Restore it from localStorage so the modal
  // comes back instead of silently losing track of an in-flight payment.
  useEffect(async () => {
    if (!booking_id) {
      return;
    }
    const stored = localStorage.getItem(qrTransactionStorageKey(booking_id));
    if (!stored) {
      return;
    }
    let parsed;
    try {
      parsed = JSON.parse(stored);
    } catch (error) {
      localStorage.removeItem(qrTransactionStorageKey(booking_id));
      return;
    }
    if (!parsed?.transaction_code) {
      localStorage.removeItem(qrTransactionStorageKey(booking_id));
      return;
    }
    try {
      const {
        data: { data },
      } = await bookingActions.getQrStatus(parsed.transaction_code);
      if (data.status === 4) {
        setQrTransaction(parsed);
        onOpenQrTransactionModal();
      } else {
        localStorage.removeItem(qrTransactionStorageKey(booking_id));
      }
    } catch (error) {
      console.error('Error restoring pending QR transaction:', error);
    }
  }, [booking_id]);

  // Poll the transaction outcome while the QR modal is open. Status 4 means
  // still waiting; anything else means OnePay resolved it — reload and close.
  useEffect(() => {
    if (!isOpenQrTransactionModal || !qrTransaction?.transaction_code) {
      return;
    }
    const interval = setInterval(async () => {
      try {
        const {
          data: { data },
        } = await bookingActions.getQrStatus(qrTransaction.transaction_code);
        if (data.status !== 4) {
          clearInterval(interval);
          closeQrTransactionModal();
          setActionReloadPage(Math.random());
        }
      } catch (error) {
        console.error('Error checking QR transaction status:', error);
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [isOpenQrTransactionModal, qrTransaction?.transaction_code]);

  // Mirrors the VietQR modal to the Customer Display so the guest can scan
  // it straight off the counter screen. null clears it (paid/expired/closed).
  useEffect(() => {
    customerDisplayChannelRef.current?.postMessage({
      type: 'qr-payment',
      data: qrTransaction?.qr_code
        ? {
            qrValue: atob(qrTransaction.qr_code),
            amount: qrTransaction.amount ? parseInt(qrTransaction.amount) : null,
            expiryAt: qrTransaction.qr_expiry_time,
          }
        : null,
    });
  }, [qrTransaction]);
  async function onSubmitAddExtendBooking({ validity }) {
    try {
      const res = await bookingActions.addExtendBooking(
        {
          validity: new Date(validity).toISOString(),
        },
        booking_id
      );
      if (res.status === 200) {
        toast({
          description: `Add Extend Booking successful`,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
        setActionReloadPage(Math.random());
        onCloseAddExtendBookingModal();
        // resetAddExtendBooking();
        setErrorAddExtendBooking('apiError', {
          message: '',
        });
      }
    } catch (error) {
      console.warn(error);
    }
  }

  async function onSubmitCancelBooking({ optionCancel, noteCancel }) {
    try {
      let items = [];
      let amount = 0;
      if (bookingDetail && bookingDetail.booking_payment) {
        items = bookingDetail.booking_payment.map((i, index) => {
          if (optionCancel == FEStatusCancelWithout) {
            return {
              type: parseInt(optionCancel) || 0,
              note: noteCancel,
              amount: 0,
              refund_method: 0,
            };
          }

          amount = parseInt(
            watchCancelBooking(`amountCancel[${index}]`)?.replace(/,/g, '') || 0
          );
          if (amount === 0) {
            setErrorCancelBooking('apiError', {
              message: 'Amount should be greater than 0',
            });
            return;
          } else if (amount > i.amount) {
            setErrorCancelBooking('apiError', {
              message:
                'Amount should be equal to or less than Max ' +
                i.amount.toLocaleString('en-US'),
            });
            return;
          }

          return {
            type: parseInt(optionCancel) || 0,
            note: noteCancel,
            amount: amount,
            refund_method: parseInt(
              watchCancelBooking(`paymentMethodCancel[${index}]`)?.replace(
                /,/g,
                ''
              ) || 0
            ),
          };
        });
      } else if (
        bookingDetail &&
        (bookingDetail?.payment_type === PaymentTypeLiability ||
          bookingDetail?.payment_type === PaymentTypeUnpaid ||
          bookingDetail?.payment_type === PaymentTypePaid)
      ) {
        if (optionCancel == FEStatusCancelWithout) {
          items = [
            {
              type: parseInt(optionCancel) || 0,
              note: noteCancel,
              amount: 0,
              refund_method: 0,
            },
          ];
        } else {
          amount = parseInt(
            watchCancelBooking(`amountCancel[0]`)?.replace(/,/g, '') || 0
          );
          if (amount == 0) {
            setErrorCancelBooking('apiError', {
              message: 'Amount should be greater than 0',
            });
            return;
          } else if (amount > parseInt(bookingDetail.total_amount)) {
            setErrorCancelBooking('apiError', {
              message:
                'Amount should be equal to or less than Max ' +
                bookingDetail.total_amount.toLocaleString('en-US'),
            });
            return;
          } else {
            items = [
              {
                type: parseInt(optionCancel) || 0,
                note: noteCancel,
                amount: amount,
                refund_method: parseInt(
                  watchCancelBooking(`paymentMethodCancel[${0}]`)?.replace(
                    /,/g,
                    ''
                  ) || 0
                ),
              },
            ];
          }
        }
      }
      const res = await bookingActions.cancelBookingAdminTool(
        {
          items,
        },
        booking_id
      );
      if (res.status === 200) {
        toast({
          description: `Cancel Booking successful`,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
        setActionReloadPage(Math.random());
        onCloseCancelBookingModal();
        resetCancelBooking();
        setErrorCancelBooking('apiError', {
          message: '',
        });
      }
    } catch (error) {
      setErrorCancelBooking('apiError', {
        message: error.response.data.meta.message,
      });
      console.warn(error);
    }
  }
  const Unpaid = 3;
  const Cancel = 2;
  async function showViewHistory() {
    onOpenViewHistoryModal();
    const {
      data: { data: historyBooking },
    } = await bookingActions.getHistoriesBooking(booking_id);
    setListHistoryBooking(historyBooking);
  }
  async function showViewSeatHistory(bookingDetailID) {
    onOpenViewSeatHistoryModal();
    const {
      data: { data: historyBookingDetail },
    } = await bookingActions.getHistoriesBookingDetail(bookingDetailID, 200, 0);
    setListHistoryBookingDetail(historyBookingDetail);
  }
  async function showViewPaymentHistory(bookingPaymentID) {
    setListHistoryBookingPayment([]);
    onOpenViewPaymentHistoryModal();
    const {
      data: { data: historyBookingPayment },
    } = await bookingActions.getHistoriesBookingPayment(bookingPaymentID, 200, 0);
    setListHistoryBookingPayment(historyBookingPayment);
  }
  // Payments without an id (older API) can't be selected: they'd all match
  // `undefined` and check every row at once.
  const allPaymentIDs = (bookingDetail?.booking_payment || [])
    .map((p) => p.id)
    .filter((id) => id != null);
  const isAllPaymentsSelected =
    allPaymentIDs.length > 0 &&
    allPaymentIDs.every((id) => selectedPaymentIDs.includes(id));
  function togglePaymentSelected(paymentID) {
    setSelectedPaymentIDs((prev) =>
      prev.includes(paymentID)
        ? prev.filter((id) => id !== paymentID)
        : [...prev, paymentID]
    );
  }
  // print-payment-receipt renders one receipt for all selected payments and
  // records the print (print_count + history) in one call; reload so the
  // Printed column updates.
  async function printPaymentReceipt() {
    if (isPrintingReceipt || selectedPaymentIDs.length === 0) return;
    setIsPrintingReceipt(true);
    try {
      const ids = selectedPaymentIDs.join(',');
      const response = await bookingActions.printPaymentReceiptPDF(booking_id, ids);
      if (receiptPdfUrl) URL.revokeObjectURL(receiptPdfUrl);
      const url = URL.createObjectURL(response.data);
      setReceiptPdfUrl(url);
      if (!openPdfInNewTab(url)) onOpenPaymentReceiptModal();
      setActionReloadPage(Math.random());
    } catch (error) {
      toast({
        description: error?.response?.data?.meta?.message || 'Print bill failed',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    } finally {
      setIsPrintingReceipt(false);
    }
  }
  async function showViewEmailHistory() {
    onOpenViewEmailHistoryModal();
    try {
      const {
        data: { data: emailHistory },
      } = await notificationActions.getEmailHistoryByBooking(
        bookingDetail?.code
      );
      setListEmailHistory(emailHistory);
    } catch (error) {
      console.warn(error);
      setListEmailHistory([]);
    }
  }
  async function onSubmitPublishInvoice({
    email,
    invoice_issuer,
    company_name,
    tax_code,
    company_address,
  }) {
    const params = {
      booking_id: bookingDetail.id,
      company_name,
      tax_code,
      company_address,
      email,
      invoice_issuer: parseInt(invoice_issuer),
    };
    try {
      const res = await bookingActions.publishInvoice(params);
      if (res.status === 200) {
        onClosePublishInvoiceModal();
        toast({
          description: 'Publish Invoice success',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (err) {
      console.warn(err);
    }
  }
  async function onSubmitSendETicket({ email, emailCc, subject, eTicketType, content }) {
    const params = {
      'e-ticket-type': parseInt(eTicketType),
      subject,
      content,
      email,
      email_cc: emailCc || '',
    };
    try {
      const res = await bookingActions.sendETicket(params, booking_id);
      if (res.status === 200) {
        onCloseSendETicketModal();
        toast({
          description: 'Send success',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
        resetSendETicket();
      }
    } catch (err) {
      resetSendETicket();
      console.warn(err);
    }
  }
  const textColorIcon = useColorModeValue('blue.500', 'white');

  function getSubject(lang, type) {
    let prefix;
    if (type === 'eticket') {
      prefix = lang === 'vi' ? 'VÉ ĐIỆN TỬ CỦA MÃ ĐẶT VÉ ' : 'ETICKET FOR BOOKING ';
    } else if (type === 'info') {
      prefix = lang === 'vi' ? 'THÔNG TIN CỦA MÃ ĐẶT VÉ ' : 'BOOKING INFORMATION FOR BOOKING ';
    } else if (type === 'theaterpass') {
      prefix = lang === 'vi' ? 'THẺ VÀO KHÁN PHÒNG CỦA MÃ ĐẶT VÉ ' : 'THEATER PASS FOR BOOKING ';
    }
    const show = bookingDetail?.show_schedule_detail?.show_schedule?.show;
    const showName = lang === 'vi' ? show?.name_vi || show?.name : show?.name;
    return '[' + showName + '] - ' + prefix + bookingDetail?.code;
  }

  function hasPrintedSeat() {
    if (!bookingDetail?.booking_detail || !Array.isArray(bookingDetail.booking_detail)) {
      return false;
    }
    return bookingDetail.booking_detail.some((seat) => seat.status === 1);
  }

  function enableCancelWithRefund() {
    if (!bookingDetail || !Array.isArray(bookingDetail.booking_payment)) {
      return false;
    }
    return !(
      bookingDetail.booking_payment.filter((i) => i.payment_method === 7)
        .length === bookingDetail.booking_payment.length
    );
  }

  return (
    <Card>
      <CardHeader px='22px'>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenViewHistoryModal}
          onClose={() => {
            onCloseViewHistoryModal();
            reset();
          }}
          size='6xl'
        >
          <ModalOverlay />
          <form id='view-history-form'>
            <ModalContent>
              <ModalHeader>View History</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Box overflowX={'auto'}>
                  <Table variant='simple' color={textColor}>
                    <Thead>
                      <Tr my='.8rem' pl='0px' color='gray.400'>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Action
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Updated by
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          History
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Updated at
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {listHistoryBooking?.map((item, index) => (
                        <Tr key={index}>
                          <Td
                            borderColor={borderColor}
                            p='16px 12px'
                            borderRight='1px solid gray'
                          >
                            <Text fontSize='xs' color={textColor}>
                              {item?.history_action}
                            </Text>
                          </Td>
                          <Td
                            borderColor={borderColor}
                            p='16px 12px'
                            borderRight='1px solid gray'
                          >
                            <Text fontSize='xs' color={textColor}>
                              {item?.history_user_mail}
                            </Text>
                          </Td>
                          <Td
                            borderColor={borderColor}
                            p='16px 12px'
                            borderRight='1px solid gray'
                          >
                            <Box fontSize='xs' color={textColor}>
                              {item?.diff &&
                                item.diff.map((i, index) => {
                                  return (
                                    <Box key={index}>
                                      <Text fontSize='base' fontWeight='bold'>
                                        {Array.isArray(i.path) ? i.path.join('.') : i.path}
                                      </Text>

                                      <Box
                                        dangerouslySetInnerHTML={{
                                          __html: (Array.isArray(i.path) && (i.path.includes('ExpireAt') || i.path.includes('InvoiceResponseAt'))) || i.path === 'ExpireAt' || i.path === 'InvoiceResponseAt'
                                            ? moment(i.to).format('DD/MM/YYYY HH:mm:ss')
                                            : i.to,
                                        }}
                                      ></Box>
                                    </Box>
                                  );
                                })}
                            </Box>
                          </Td>

                          <Td borderColor={borderColor} p='16px 12px'>
                            <Text fontSize='xs' color={textColor}>
                              {moment(item?.created_at).format(
                                'DD/MM/YYYY HH:mm:ss'
                              )}
                            </Text>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
              </ModalBody>
              <ModalFooter pt='0'>
                <Button
                  onClick={() => {
                    onCloseViewHistoryModal();
                    reset();
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenViewSeatHistoryModal}
          onClose={() => {
            onCloseViewSeatHistoryModal();
          }}
          size='6xl'
        >
          <ModalOverlay />
          <form id='view-seat-history-form'>
            <ModalContent>
              <ModalHeader>View Seat History</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Box overflowX={'auto'}>
                  <Table variant='simple' color={textColor}>
                    <Thead>
                      <Tr my='.8rem' pl='0px' color='gray.400'>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Action
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Updated by
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          History
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Updated at
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {listHistoryBookingDetail?.map((item, index) => (
                        <Tr key={index}>
                          <Td
                            borderColor={borderColor}
                            p='16px 12px'
                            borderRight='1px solid gray'
                          >
                            <Text fontSize='xs' color={textColor}>
                              {item?.history_action}
                            </Text>
                          </Td>
                          <Td
                            borderColor={borderColor}
                            p='16px 12px'
                            borderRight='1px solid gray'
                          >
                            <Text fontSize='xs' color={textColor}>
                              {item?.history_user_mail}
                            </Text>
                          </Td>
                          <Td
                            borderColor={borderColor}
                            p='16px 12px'
                            borderRight='1px solid gray'
                          >
                            <Box fontSize='xs' color={textColor}>
                              {item?.diff &&
                                item.diff.map((i, index) => {
                                  return (
                                    <Box key={index}>
                                      <Text fontSize='base' fontWeight='bold'>
                                        {Array.isArray(i.path) ? i.path.join('.') : i.path}
                                      </Text>

                                      <Box
                                        dangerouslySetInnerHTML={{
                                          __html: (Array.isArray(i.path) && (i.path.includes('ExpireAt') || i.path.includes('InvoiceResponseAt') || i.path.includes('CheckinAt'))) || i.path === 'ExpireAt' || i.path === 'InvoiceResponseAt' || i.path === 'CheckinAt'
                                            ? moment(i.to).format('DD/MM/YYYY HH:mm:ss')
                                            : i.to,
                                        }}
                                      ></Box>
                                    </Box>
                                  );
                                })}
                            </Box>
                          </Td>

                          <Td borderColor={borderColor} p='16px 12px'>
                            <Text fontSize='xs' color={textColor}>
                              {moment(item?.created_at).format(
                                'DD/MM/YYYY HH:mm:ss'
                              )}
                            </Text>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
              </ModalBody>
              <ModalFooter pt='0'>
                <Button
                  onClick={() => {
                    onCloseViewSeatHistoryModal();
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenViewPaymentHistoryModal}
          onClose={onCloseViewPaymentHistoryModal}
          size='3xl'
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>View Payment History</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <Box overflowX={'auto'}>
                <Table variant='simple' color={textColor}>
                  <Thead>
                    <Tr my='.8rem' pl='0px' color='gray.400'>
                      <Th borderColor={borderColor} p='16px 12px'>
                        Action
                      </Th>
                      <Th borderColor={borderColor} p='16px 12px'>
                        Updated by
                      </Th>
                      <Th borderColor={borderColor} p='16px 12px'>
                        Updated at
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {listHistoryBookingPayment?.length > 0 ? (
                      listHistoryBookingPayment.map((item, index) => (
                        <Tr key={index}>
                          <Td borderColor={borderColor} p='16px 12px'>
                            <Text fontSize='xs' color={textColor}>
                              {item?.history_action}
                            </Text>
                          </Td>
                          <Td borderColor={borderColor} p='16px 12px'>
                            <Text fontSize='xs' color={textColor}>
                              {item?.history_user_mail}
                            </Text>
                          </Td>
                          <Td borderColor={borderColor} p='16px 12px'>
                            <Text fontSize='xs' color={textColor}>
                              {moment(item?.created_at).format(
                                'DD/MM/YYYY HH:mm:ss'
                              )}
                            </Text>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={3} textAlign='center' borderColor={borderColor}>
                          <Text fontSize='xs' color='gray.400'>
                            No history
                          </Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </Box>
            </ModalBody>
            <ModalFooter pt='0'>
              <Button onClick={onCloseViewPaymentHistoryModal}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenPaymentReceiptModal}
          onClose={onClosePaymentReceiptModal}
          size='3xl'
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Print Bill</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              {receiptPdfUrl && (
                // The 80mm receipt is narrow: hide the thumbnail pane and fit
                // to width so the cashier can read it before printing.
                <iframe
                  title='Payment Receipt'
                  src={`${receiptPdfUrl}#navpanes=0&view=FitH`}
                  width='100%'
                  style={{ height: '75vh' }}
                />
              )}
            </ModalBody>
            <ModalFooter pt='0'>
              <Button onClick={onClosePaymentReceiptModal}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal
          isOpen={isOpenETicketModal}
          onClose={closeETicketModal}
          size={isETicketFullScreen ? 'full' : '5xl'}
        >
          <ModalOverlay />
          <ModalContent borderRadius={isETicketFullScreen ? 0 : 'md'}>
            <ModalHeader pr={12} fontSize={{ base: 'md', md: 'xl' }}>
              {eTicketPdf?.title}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody
              display='flex'
              flexDirection='column'
              px={{ base: 2, md: 6 }}
              pb={{ base: 2, md: 6 }}
            >
              {eTicketPdf && (
                // toolbar=0 hides the viewer's download button, which would
                // name the file after the blob UUID; use the Download button below.
                <iframe
                  title={eTicketPdf.title}
                  src={`${eTicketPdf.url}#toolbar=0&navpanes=0&view=FitH`}
                  width='100%'
                  style={isETicketFullScreen ? { flex: 1 } : { height: '75vh' }}
                />
              )}
            </ModalBody>
            <ModalFooter pt='0' gap={3}>
              <Button colorScheme='blue' onClick={downloadETicket}>
                Download
              </Button>
              <Button onClick={closeETicketModal}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenAddPaymentModal}
          onClose={() => {
            // Prevent closing modal while payment is being added
            if (isAddingPayment) {
              return;
            }
            onCloseAddPaymentModal();
            resetAddPayment();
            reset();
          }}
          size='xl'
        >
          <ModalOverlay />
          <form
            id='add-payment-method-form'
            onSubmit={handleSubmitAddPayment(onSubmitAddPayment)}
          >
            <ModalContent>
              <ModalHeader>Add Payment</ModalHeader>
              <ModalCloseButton isDisabled={isAddingPayment} />
              <ModalBody pb={6}>
                <Grid gap='16px' mb={3}>
                  <Flex direction='column'>
                    <FormControl>
                      <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                        Remaining Amount:{' '}
                        {remainingAmount
                          ? remainingAmount.toLocaleString('en-US')
                          : 0}{' '}
                        VND
                      </FormLabel>
                    </FormControl>
                  </Flex>
                </Grid>
                <Grid gap='16px' mb={3}>
                  <Flex direction='column'>
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                        Payment Method
                      </FormLabel>
                      <Select
                        ms='4px'
                        type='text'
                        placeholder=''
                        size='sm'
                        name='paymentMethod'
                        {...paymentMethodField}
                        onChange={(e) => {
                          // Keep react-hook-form in sync so the cash fields toggle right away
                          paymentMethodField.onChange(e);
                          handlePaymentMethodChange(e);
                        }}
                        isInvalid={errors.paymentMethod}
                        control={controlPayment}
                      >
                        {listPaymentMethod.map((item, index) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Select>
                      <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                        {errors.paymentMethod?.message}
                      </Text>
                    </FormControl>
                  </Flex>
                </Grid>
                <Grid gap='16px' mb={3}>
                  <Flex direction='column'>
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                        Amount
                      </FormLabel>
                      <Controller
                        name='amount'
                        control={controlPayment}
                        render={({ field }) => (
                          <NumericFormat
                            customInput={Input}
                            thousandSeparator=','
                            fontSize='base'
                            ms='4px'
                            placeholder='Amount'
                            size='sm'
                            {...field}
                            onChange={(e) => {
                              field.onChange(e);
                              setValuePayment('receivedAmount', e.target.value);
                            }}
                            className='amount'
                          />
                        )}
                      />
                      <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                        {errors.amount?.message}
                      </Text>
                    </FormControl>
                  </Flex>
                </Grid>
                {isCashAddPayment && (
                  <Grid gap='16px' mb={3}>
                    <Flex direction='column'>
                      <FormControl>
                        <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                          Received Amount
                        </FormLabel>
                        <Controller
                          name='receivedAmount'
                          control={controlPayment}
                          render={({ field }) => (
                            <NumericFormat
                              customInput={Input}
                              thousandSeparator=','
                              fontSize='base'
                              ms='4px'
                              size='sm'
                              {...field}
                              onBlur={() => {
                                field.onBlur();
                                // Never below Amount: an empty or smaller value snaps back to Amount
                                if (addPaymentReceived < addPaymentAmount) {
                                  setValuePayment('receivedAmount', addPaymentAmount);
                                }
                              }}
                              className='amount'
                            />
                          )}
                        />
                        {addPaymentReceived > 0 &&
                          addPaymentReceived >= addPaymentAmount && (
                            <Text ms='4px' mt='6px' fontSize='base'>
                              Change:{' '}
                              <b>
                                {(addPaymentReceived - addPaymentAmount).toLocaleString('en-US')}{' '}
                                VND
                              </b>
                            </Text>
                          )}
                        <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                          {errors.receivedAmount?.message}
                        </Text>
                      </FormControl>
                    </Flex>
                  </Grid>
                )}
                <Text color='red' ml='5px'>
                  {errors.apiError && errors.apiError?.message}
                </Text>
              </ModalBody>
              <ModalFooter pt='0'>
                <Button
                  isLoading={isAddingPayment || isSubmittingAddPayment}
                  disabled={isAddingPayment || isSubmittingAddPayment}
                  colorScheme='blue'
                  mr={3}
                  type='submit'
                >
                  Add
                </Button>
                <Button
                  onClick={onCloseAddPaymentModal}
                  disabled={isAddingPayment}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenCreateTransactionModal}
          onClose={() => {
            // Prevent closing modal while transaction is being created
            if (isCreatingTransaction) {
              return;
            }
            onCloseCreateTransactionModal();
            resetCreateTransaction();
          }}
          size='xl'
        >
          <ModalOverlay />
          <form
            id='create-transaction-form'
            onSubmit={handleSubmitCreateTransaction(onSubmitCreateTransaction)}
          >
            <ModalContent>
              <ModalHeader>Create Transaction (VietQR)</ModalHeader>
              <ModalCloseButton isDisabled={isCreatingTransaction} />
              <ModalBody pb={6}>
                <Grid gap='16px' mb={3}>
                  <Flex direction='column'>
                    <FormControl>
                      <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                        Remaining Amount:{' '}
                        {remainingAmount
                          ? remainingAmount.toLocaleString('en-US')
                          : 0}{' '}
                        VND
                      </FormLabel>
                    </FormControl>
                  </Flex>
                </Grid>
                <Grid gap='16px' mb={3}>
                  <Flex direction='column'>
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                        Amount
                      </FormLabel>
                      <Controller
                        name='amount'
                        control={controlCreateTransaction}
                        render={({ field }) => (
                          <NumericFormat
                            customInput={Input}
                            thousandSeparator=','
                            fontSize='base'
                            ms='4px'
                            placeholder='Amount'
                            size='sm'
                            {...field}
                            className='amount'
                          />
                        )}
                      />
                      <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                        {errorsCreateTransaction.amount?.message}
                      </Text>
                    </FormControl>
                  </Flex>
                </Grid>
              </ModalBody>
              <ModalFooter pt='0'>
                <Button
                  isLoading={isCreatingTransaction || isSubmittingCreateTransaction}
                  disabled={isCreatingTransaction || isSubmittingCreateTransaction}
                  colorScheme='blue'
                  mr={3}
                  type='submit'
                >
                  Create
                </Button>
                <Button
                  onClick={onCloseCreateTransactionModal}
                  disabled={isCreatingTransaction}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          closeOnEsc={false}
          isOpen={isOpenQrTransactionModal}
          onClose={closeQrTransactionModal}
          size='sm'
          isCentered
        >
          <ModalOverlay />
          <ModalContent mx={{ base: 4, md: 0 }}>
            <ModalHeader>Scan to Pay (VietQR)</ModalHeader>
            <ModalBody pb={6}>
              <Flex direction='column' align='center' gap={3}>
                {qrTransaction?.qr_code && (
                  <QRCode value={atob(qrTransaction.qr_code)} size={220} level={'M'} />
                )}
                <Text fontSize='base' fontWeight='700'>
                  {qrTransaction?.amount
                    ? `${parseInt(qrTransaction.amount).toLocaleString('en-US')} VND`
                    : ''}
                </Text>
                {qrTransaction?.qr_expiry_time && (
                  <Text fontSize='sm' color={textColor}>
                    Expires at{' '}
                    {moment(qrTransaction.qr_expiry_time).format(
                      'DD/MM/YYYY HH:mm:ss'
                    )}
                  </Text>
                )}
                <Flex align='center' gap={2}>
                  <Text fontSize='sm' color='orange.500'>
                    Waiting for payment...
                  </Text>
                </Flex>
              </Flex>
            </ModalBody>
            <ModalFooter pt={2} justifyContent='flex-start'>
              <Text
                fontSize='sm'
                textDecoration='underline'
                cursor='pointer'
                onClick={onOpenCancelTransactionModal}
              >
                Cancel
              </Text>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenCancelTransactionModal}
          onClose={() => {
            if (isCancellingTransaction) {
              return;
            }
            onCloseCancelTransactionModal();
          }}
          size='md'
          isCentered
        >
          <ModalOverlay />
          <ModalContent mx={{ base: 4, md: 0 }}>
            <ModalBody pt={6} pb={4}>
              <Flex align='center' gap={2} mb={3}>
                <Text fontSize='xl'>⚠️</Text>
                <Text fontWeight='semibold' fontSize='md' color='orange.500'>
                  Cancel Transaction
                </Text>
              </Flex>
              <Text fontSize='sm' color={textColor}>
                Are you sure you want to cancel this transaction? This QR code
                will no longer be payable and this action cannot be undone.
              </Text>
            </ModalBody>
            <ModalFooter pt={2} pb={4} gap={3}>
              <Button
                size='sm'
                colorScheme='red'
                isLoading={isCancellingTransaction}
                onClick={handleCancelTransaction}
              >
                Cancel Transaction
              </Button>
              <Button
                size='sm'
                onClick={onCloseCancelTransactionModal}
                isDisabled={isCancellingTransaction}
              >
                Go Back
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpen}
          onClose={() => {
            onClose();
            reset();
          }}
          size='xl'
        >
          <ModalOverlay />
          <form id='add-special-request-form' onSubmit={handleSubmit(onSubmit)}>
            <ModalContent>
              <ModalHeader>Add Special Request</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Grid gap='16px'  mb={3} display={{base: 'block', lg: 'grid'}}>
                  <FormControl isRequired>
                    <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                      Note
                    </FormLabel>
                    <Textarea
                      name='note'
                      {...register('note')}
                      isInvalid={errors.note}
                      rows={8}
                    />

                    <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                      {errors.note?.message}
                    </Text>
                  </FormControl>
                </Grid>
                <Text color='red' ml='5px'>
                  {errors.apiError && errors.apiError?.message}
                </Text>
              </ModalBody>
              <ModalFooter pt='0'>
                <Button
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                  colorScheme='blue'
                  mr={3}
                  type='submit'
                >
                  Create
                </Button>
                <Button
                  onClick={() => {
                    onClose();
                    reset();
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenAddExtendBookingModal}
          onClose={() => {
            onCloseAddExtendBookingModal();
            resetAddExtendBooking();
          }}
          size='xl'
        >
          <ModalOverlay />
          <form
            id='add-extend-booking-form'
            onSubmit={handleSubmitAddExtendBooking(onSubmitAddExtendBooking)}
          >
            <ModalContent>
              <ModalHeader>Add Extend Booking</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Grid gap='16px' mb={3}>
                  <Flex direction='column'>
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                        Validity
                      </FormLabel>
                      <Controller
                        name='validity'
                        control={controlAddExtendBooking}
                        render={({ field }) => (
                          <ReactDatePicker
                            {...field}
                            calendarStartDay={1}
                            filterTime={filterPassedTime}
                            closeOnScroll={false}
                            timeFormat='hh:mm aa'
                            customInput={<Input autoComplete='off' />}
                            showTimeSelect
                            selected={field?.value}
                            dateFormat='dd/MM/yyyy hh:mm aa'
                            className='booking-date-range-search'
                            minDate={new Date()}
                            maxDate={new Date(moment(bookingDetail?.showdate))}
                            minTime={
                              validateTime &&
                              validateTime?.toDateString() ===
                                new Date(
                                  new Date(bookingDetail?.showdate)
                                )?.toDateString()
                                ? setHours(setMinutes(new Date(), 0), 0)
                                : new Date(validateTime).getDate() ===
                                  new Date().getDate()
                                ? setHours(
                                    setMinutes(
                                      new Date(),
                                      new Date().getMinutes()
                                    ),
                                    new Date().getHours()
                                  )
                                : setHours(setMinutes(new Date(), 0), 0)
                            }
                            maxTime={
                              validateTime &&
                              validateTime?.toDateString() ===
                                new Date(
                                  new Date(bookingDetail?.showdate)
                                ).toDateString()
                                ? setHours(
                                    setMinutes(new Date(), 15),
                                    parseInt(
                                      bookingDetail?.showtime.slice(0, 2)
                                    )
                                  )
                                : setHours(setMinutes(new Date(), 30), 23)
                            }
                            onChange={(value) => {
                              field.onChange(value);
                            }}
                          />
                        )}
                      />
                      <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                        {errorsExtendBooking.validity?.message}
                      </Text>
                    </FormControl>
                  </Flex>
                </Grid>

                <Text color='red' ml='5px'>
                  {errorsExtendBooking.apiError &&
                    errorsExtendBooking.apiError?.message}
                </Text>
              </ModalBody>
              <ModalFooter pt='0'>
                <Button
                  isLoading={isSubmittingExtendBooking}
                  disabled={isSubmittingExtendBooking}
                  colorScheme='blue'
                  mr={3}
                  type='submit'
                >
                  Add
                </Button>
                <Button
                  onClick={() => {
                    onCloseAddExtendBookingModal();
                    resetAddExtendBooking();
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenCancelBookingModal}
          onClose={() => {
            onCloseCancelBookingModal();
            resetCancelBooking();
            setActionReloadPage(Math.random())
          }}
          size='xl'
        >
          <ModalOverlay />
          <form
            id='cancel-booking-method-form'
            onSubmit={handleSubmitCancelBooking(onSubmitCancelBooking)}
          >
            <ModalContent>
              <ModalHeader>Cancel Booking</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Grid gap='16px' mb={3}>
                  <Flex direction='column'>
                    <FormControl>
                      <Controller
                        name='optionCancel'
                        control={controlCancelBooking}
                        render={({ field }) => (
                          <RadioGroup {...field} defaultValue='2'>
                            <Stack direction='column' spacing={4}>
                              <Flex direction='column'>
                                <Radio value='2'>
                                  Cancel without{' '}
                                  {bookingDetail?.payment_type ===
                                    PaymentTypePaid ||
                                  bookingDetail?.payment_type ===
                                    PaymentTypeUnpaid
                                    ? 'Refund'
                                    : 'Charge'}
                                </Radio>
                                {((bookingDetail?.booking_payment &&
                                  bookingDetail?.payment_type ===
                                    PaymentTypeUnpaid) ||
                                  (bookingDetail?.payment_type ===
                                    PaymentTypePaid &&
                                    enableCancelWithRefund()) ||
                                  bookingDetail?.payment_type ===
                                    PaymentTypeLiability) && (
                                  <Radio value='1'>
                                    Cancel with{' '}
                                    {bookingDetail?.payment_type ===
                                      PaymentTypePaid ||
                                    bookingDetail?.payment_type ===
                                      PaymentTypeUnpaid
                                      ? 'Refund'
                                      : 'Charge'}
                                  </Radio>
                                )}
                              </Flex>
                            </Stack>
                          </RadioGroup>
                        )}
                      />
                    </FormControl>

                    {optionCancel === FEStatusCancelWith &&
                      bookingDetail?.booking_payment && (
                        <Flex direction='column'>
                          {bookingDetail.booking_payment.map((i, index) => (
                            <Grid
                              templateColumns={{
                                lg: '1fr 6fr',
                              }}
                              alignItems='flex-start'
                              gap='40px'
                            >
                              <Flex gap='16px' mb={3}>
                                <Flex direction=''>
                                  <FormControl isRequired>
                                    <FormLabel
                                      ms='4px'
                                      fontSize='base'
                                      fontWeight='normal'
                                    >
                                      Amount
                                    </FormLabel>
                                    <Controller
                                      name={`amountCancel[${index}]`}
                                      control={controlCancelBooking}
                                      render={({ field }) => (
                                        <NumericFormat
                                          customInput={Input}
                                          thousandSeparator=','
                                          fontSize='base'
                                          ms='4px'
                                          placeholder='Amount'
                                          size='sm'
                                          {...field}
                                          className='amount'
                                          style={{ minWidth: '240px' }}
                                        />
                                      )}
                                    />
                                    <Text fontSize={'base'} mb='10px' ml='5px'>
                                      (Max: {i.amount.toLocaleString('en-US')})
                                    </Text>
                                    <Text
                                      color='red'
                                      fontSize={'base'}
                                      mb='10px'
                                      ml='5px'
                                    >
                                      {errorsCancelBooking.amount?.message}
                                    </Text>
                                  </FormControl>
                                </Flex>
                              </Flex>
                              <Flex gap='16px' mb={3}>
                                <Flex direction='column'>
                                  <FormControl isRequired>
                                    <FormLabel
                                      ms='4px'
                                      fontSize='base'
                                      fontWeight='normal'
                                    >
                                      Cancel Method
                                    </FormLabel>
                                    <Select
                                      ms='4px'
                                      type='text'
                                      placeholder=''
                                      size='sm'
                                      className='paymentMethodCancel'
                                      name={`paymentMethodCancel[${index}]`}
                                      {...registerCancelBooking(
                                        `paymentMethodCancel[${index}]`
                                      )}
                                      isInvalid={
                                        errorsCancelBooking.paymentMethod
                                      }
                                      control={controlCancelBooking}
                                      minWidth={'240px'}
                                    >
                                      {listPaymentMethod.map((item, index) => (
                                        <option key={item.id} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </Select>
                                    <Text
                                      color='red'
                                      fontSize={'base'}
                                      mb='10px'
                                      ml='5px'
                                    >
                                      {
                                        errorsCancelBooking.paymentMethod
                                          ?.message
                                      }
                                    </Text>
                                  </FormControl>
                                </Flex>
                              </Flex>
                            </Grid>
                          ))}
                        </Flex>
                      )}
                    {optionCancel === FEStatusCancelWith &&
                      bookingDetail?.payment_type === PaymentTypeLiability &&
                      !bookingDetail?.booking_payment && (
                        <Flex direction='column'>
                          <Grid
                            templateColumns={{
                              lg: '1fr 6fr',
                            }}
                            alignItems='flex-start'
                            gap='40px'
                          >
                            <Flex gap='16px' mb={3}>
                              <Flex direction=''>
                                <FormControl isRequired>
                                  <FormLabel
                                    ms='4px'
                                    fontSize='base'
                                    fontWeight='normal'
                                  >
                                    Amount
                                  </FormLabel>
                                  <Controller
                                    name={`amountCancel[${0}]`}
                                    control={controlCancelBooking}
                                    render={({ field }) => (
                                      <NumericFormat
                                        customInput={Input}
                                        thousandSeparator=','
                                        fontSize='base'
                                        ms='4px'
                                        placeholder='Amount'
                                        size='sm'
                                        {...field}
                                        className='amount'
                                        style={{ minWidth: '240px' }}
                                      />
                                    )}
                                  />
                                  <Text fontSize={'base'} mb='10px' ml='5px'>
                                    (Max:{' '}
                                    {bookingDetail?.total_amount.toLocaleString(
                                      'en-US'
                                    )}
                                    )
                                  </Text>
                                  <Text
                                    color='red'
                                    fontSize={'base'}
                                    mb='10px'
                                    ml='5px'
                                  >
                                    {errorsCancelBooking.amount?.message}
                                  </Text>
                                </FormControl>
                              </Flex>
                            </Flex>
                            <Flex gap='16px' mb={3}>
                              <Flex direction='column'>
                                <FormControl isRequired>
                                  <FormLabel
                                    ms='4px'
                                    fontSize='base'
                                    fontWeight='normal'
                                  >
                                    Cancel Method
                                  </FormLabel>
                                  <Select
                                    ms='4px'
                                    type='text'
                                    placeholder=''
                                    size='sm'
                                    className='paymentMethodCancel'
                                    name={`paymentMethodCancel[${0}]`}
                                    {...registerCancelBooking(
                                      `paymentMethodCancel[${0}]`
                                    )}
                                    isInvalid={
                                      errorsCancelBooking.paymentMethod
                                    }
                                    control={controlCancelBooking}
                                    minWidth={'240px'}
                                  >
                                    {listPaymentMethod.map((item, index) => (
                                      <option key={item.id} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </Select>
                                  <Text
                                    color='red'
                                    fontSize={'base'}
                                    mb='10px'
                                    ml='5px'
                                  >
                                    {errorsCancelBooking.paymentMethod?.message}
                                  </Text>
                                </FormControl>
                              </Flex>
                            </Flex>
                          </Grid>
                        </Flex>
                      )}
                  </Flex>
                </Grid>

                <Grid gap='16px' mb={3}>
                  <Flex direction='column'>
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                        Note
                      </FormLabel>
                      <Input
                        fontSize='base'
                        ms='4px'
                        type='text'
                        placeholder='Note'
                        mb={
                          errorsCancelBooking.noteCancel?.message
                            ? '5px'
                            : '24px'
                        }
                        size='md'
                        name='noteCancel'
                        {...registerCancelBooking('noteCancel')}
                        isInvalid={errorsCancelBooking.noteCancel}
                        errorBorderColor='red.300'
                      />
                      <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                        {errorsCancelBooking.noteCancel?.message}
                      </Text>
                    </FormControl>
                  </Flex>
                </Grid>
                <Text color='red' ml='5px'>
                  {errorsCancelBooking.apiError &&
                    errorsCancelBooking.apiError?.message}
                </Text>
              </ModalBody>
              <ModalFooter pt='0'>
                <Button
                  isLoading={isSubmittingCancelBooking}
                  disabled={isSubmittingCancelBooking}
                  colorScheme='blue'
                  mr={3}
                  type='submit'
                >
                  Cancel Booking
                </Button>
                <Button
                  onClick={() => {
                    onCloseCancelBookingModal();
                    resetCancelBooking();
                    setActionReloadPage(Math.random());
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>

        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenPendingTransactionModal}
          onClose={onClosePendingTransactionModal}
          size='md'
          isCentered
        >
          <ModalOverlay />
          <ModalContent mx={{ base: 4, md: 0 }}>
            <ModalBody pt={6} pb={4}>
              <Flex align='center' gap={2} mb={3}>
                <Text fontSize='xl'>⚠️</Text>
                <Text fontWeight='semibold' fontSize='md' color='orange.500'>
                  Pending Transaction Detected
                </Text>
              </Flex>
              <Text fontSize='sm' color={textColor}>
                This booking has a pending transaction being processed. Are you
                sure you want to cancel?
              </Text>
            </ModalBody>
            <ModalFooter pt={2} pb={4} gap={3}>
              <Button
                size='sm'
                colorScheme='red'
                onClick={() => {
                  onClosePendingTransactionModal();
                  onOpenCancelBookingModal();
                }}
              >
                Continue to Cancel
              </Button>
              <Button size='sm' onClick={onClosePendingTransactionModal}>
                Go Back
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenPublishInvoiceModal}
          onClose={() => {
            onClosePublishInvoiceModal();
            resetPublishInvoice();
          }}
          size='2xl'
        >
          <ModalOverlay />
          <form onSubmit={handleSubmitPublishInvoice(onSubmitPublishInvoice)}>
            <ModalContent>
              <ModalHeader color={'green'}>
                Publish invoice booking {bookingDetail?.code}
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <FormControl isRequired>
                  <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                    Company Name
                  </FormLabel>
                  <Input
                    fontSize='base'
                    ms='4px'
                    type='text'
                    placeholder='Company Name'
                    maxLength={250}
                    size='md'
                    name='company_name'
                    {...registerPublishInvoice('company_name')}
                    isInvalid={errors.company_name}
                    errorBorderColor='red.300'
                  />
                  <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                    {errors.company_name?.message}
                  </Text>
                </FormControl>
                <FormControl>
                  <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                    Tax Code
                  </FormLabel>
                  <Input
                    fontSize='base'
                    ms='4px'
                    type='text'
                    placeholder='Tax Code'
                    maxLength={250}
                    size='md'
                    name='tax_code'
                    {...registerPublishInvoice('tax_code')}
                    isInvalid={errors.tax_code}
                    errorBorderColor='red.300'
                  />
                  <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                    {errors.tax_code?.message}
                  </Text>
                </FormControl>
                <FormControl isRequired>
                  <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                    Company Address
                  </FormLabel>
                  <Input
                    fontSize='base'
                    ms='4px'
                    type='text'
                    placeholder='Company Address'
                    maxLength={250}
                    size='md'
                    name='company_address'
                    {...registerPublishInvoice('company_address')}
                    isInvalid={errors.company_address}
                    errorBorderColor='red.300'
                  />
                  <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                    {errors.company_address?.message}
                  </Text>
                </FormControl>
                <FormControl isRequired>
                  <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                    Email
                  </FormLabel>
                  <Input
                    fontSize='base'
                    ms='4px'
                    type='text'
                    placeholder='Email'
                    maxLength={250}
                    size='md'
                    name='email'
                    {...registerPublishInvoice('email')}
                    isInvalid={errors.email}
                    errorBorderColor='red.300'
                  />
                  <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                    {errors.email?.message}
                  </Text>
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Invoice issuer
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    defaultValue='0'
                    size='sm'
                    name='invoice_issuer'
                    {...registerPublishInvoice('invoice_issuer')}
                    width='120px'
                  >
                    <option value='0'>Default</option>
                    <option value='1'>SaiGon</option>
                    <option value='2'>Hoi An</option>
                    <option value='3'>Ha Noi</option>
                  </Select>
                </FormControl>
              </ModalBody>
              <ModalFooter>
                <Button
                  colorScheme='blue'
                  mr={3}
                  type='submit'
                  isLoading={isSubmittingPublish}
                >
                  Publish
                </Button>
                <Button
                  onClick={() => {
                    onClosePublishInvoiceModal();
                    resetPublishInvoice();
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>

        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenViewEmailHistoryModal}
          onClose={() => {
            onCloseViewEmailHistoryModal();
          }}
          size='6xl'
        >
          <ModalOverlay />
          <form id='view-email-history-form'>
            <ModalContent>
              <ModalHeader>View Email History</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Box overflowX={'auto'}>
                  <Table variant='simple' color={textColor}>
                    <Thead>
                      <Tr my='.8rem' pl='0px' color='gray.400'>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Subject
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Recipient
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Status
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Sent at
                        </Th>
                        <Th borderColor={borderColor} p='16px 12px'>
                          Sent By
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {listEmailHistory && listEmailHistory.length > 0 ? (
                        listEmailHistory.map((item, index) => (
                          <Tr key={index}>
                            <Td borderColor={borderColor} p='16px 12px'>
                              <Text fontSize='xs' color={textColor}>
                                {item?.subject}
                              </Text>
                            </Td>
                            <Td borderColor={borderColor} p='16px 12px'>
                              {item?.identity?.split(';').map((email, emailIndex) => (
                                <Text key={emailIndex} fontSize='xs' color={textColor}>
                                  {email.trim()}
                                </Text>
                              ))}
                            </Td>
                            <Td borderColor={borderColor} p='16px 12px'>
                              <Text fontSize='xs' color={textColor}>
                                {item?.status}
                              </Text>
                            </Td>
                            <Td borderColor={borderColor} p='16px 12px'>
                              <Text fontSize='xs' color={textColor}>
                                {moment(item?.created_at).format(
                                  'DD/MM/YYYY HH:mm:ss'
                                )}
                              </Text>
                            </Td>
                            <Td borderColor={borderColor} p='16px 12px'>
                              <Text fontSize='xs' color={textColor}>
                                {item?.created_by}
                              </Text>
                            </Td>
                          </Tr>
                        ))
                      ) : (
                        <Tr>
                          <Td colSpan={5} textAlign='center' p='16px 12px'>
                            <Text fontSize='sm' color='gray.500'>
                              No email history found
                            </Text>
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </Box>
              </ModalBody>
              <ModalFooter pt='0'>
                <Button
                  onClick={() => {
                    onCloseViewEmailHistoryModal();
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>

        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpenSendETicketModal}
          onClose={() => {
            onCloseSendETicketModal();
            resetSendETicket();
          }}
          size='2xl'
        >
          <ModalOverlay />
          <form onSubmit={handleSubmitSendETicket(onSubmitSendETicket)}>
            <ModalContent>
              <ModalHeader color={'green'}>Send Email</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <FormControl isRequired>
                  <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                    Email
                  </FormLabel>
                  <Input
                    defaultValue={bookerandguestInfo.guest_email}
                    fontSize='base'
                    ms='4px'
                    type='text'
                    placeholder='Email'
                    maxLength={250}
                    size='md'
                    name='email'
                    {...registerSendETicket('email')}
                    isInvalid={errors.email}
                    errorBorderColor='red.300'
                  />
                  <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                    {errors.email?.message}
                  </Text>
                </FormControl>
                <FormControl>
                <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                  Email CC
                </FormLabel>
                <Tooltip 
                  hasArrow 
                  label='Multiple emails separated by commas. Example: user1@example.com,user2@example.com,user3@example.com' 
                  bg='gray.600'
                  color='white'
                  fontSize='sm'
                  placement='top'
                >
                  <Input
                    defaultValue={bookerandguestInfo.booker_email}
                    fontSize='base'
                    ms='4px'
                    type='text'
                    placeholder='Email CC (optional)'
                    maxLength={250}
                    size='md'
                    name='emailCc'
                    {...registerSendETicket('emailCc')}
                    isInvalid={errors.emailCc}
                    errorBorderColor='red.300'
                  />
                </Tooltip>
                <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                  {errors.emailCc?.message}
                </Text>
              </FormControl>
                <FormControl>
                  <FormLabel ms='4px' fontSize='base' fontWeight='normal'>
                    Subject
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    defaultValue='0'
                    size='sm'
                    name='subject'
                    {...registerSendETicket('subject')}
                  >
                    {bookingDetail?.payment_type !== Unpaid && (
                      <>
                        <option value={getSubject('en', 'eticket')}>{getSubject('en', 'eticket')}</option>
                        <option value={getSubject('vi', 'eticket')}>{getSubject('vi', 'eticket')}</option>
                      </>
                    )}
                    <option value={getSubject('en', 'info')}>{getSubject('en', 'info')}</option>
                    <option value={getSubject('vi', 'info')}>{getSubject('vi', 'info')}</option>
                    {hasPrintedSeat() && (
                      <>
                        <option value={getSubject('en', 'theaterpass')}>{getSubject('en', 'theaterpass')}</option>
                        <option value={getSubject('vi', 'theaterpass')}>{getSubject('vi', 'theaterpass')}</option>
                      </>
                    )}
                  </Select>
                  <Text color='red' fontSize={'base'} mb='10px' ml='5px'>
                    {errors.subject?.message}
                  </Text>
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Type
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    defaultValue='0'
                    size='sm'
                    name='eTicketType'
                    {...registerSendETicket('eTicketType')}
                  >
                    {bookingDetail?.payment_type !== Unpaid && (
                      <>
                        <option value='1'>E-ticket B2C English</option>
                        <option value='2'>E-ticket B2C Tiếng Việt</option>
                        <option value='3'>E-ticket B2B English</option>
                        <option value='4'>E-ticket B2B Tiếng Việt</option>
                      </>
                    )}
                    <option value='5'>Booking information English</option>
                    <option value='6'>Booking information Tiếng Việt</option>
                    {hasPrintedSeat() && (
                      <>
                        <option value='7'>Theater Pass English</option>
                        <option value='8'>Theater Pass Tiếng Việt</option>
                      </>
                    )}
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Content
                  </FormLabel>
                  <Editor name='content' control={controlSendETicket} />
                </FormControl>
              </ModalBody>
              <ModalFooter>
                <Button
                  colorScheme='blue'
                  mr={3}
                  type='submit'
                  isLoading={isSubmittingETicket}
                >
                  Send
                </Button>
                <Button
                  onClick={() => {
                    onCloseSendETicketModal();
                    resetSendETicket();
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>
      </CardHeader>
      <CardBody>
        <Box>
          <Box display={{ base: 'block', lg: 'inline-block' }}>
            <Grid
              templateColumns={{ base: '1fr', md: 'repeat(3, auto)' }}
              gap='16px'
            >
              <Flex direction='column'>
                <Text fontSize='lg' fontWeight='bold' mb='10px'>
                  Booking Details
                </Text>
                <Flex align='center' gap={2} mb={2}>
                  <Text fontSize='base' color='#718096' minW={{ base: '100px', lg: '110px' }}>
                    Booking No.:
                  </Text>
                  <Text
                    fontSize='base'
                    fontWeight='bold'
                    color='var(--chakra-colors-blue-500)'
                  >
                    {bookingDetail?.code}
                  </Text>
                </Flex>
                <Flex align='center' gap={2} mb={2}>
                  <Text fontSize='base' color='#718096' minW={{ base: '100px', lg: '110px' }}>
                    Booked Date:
                  </Text>
                  <Text
                    fontSize='base'
                    fontWeight='bold'
                    color='#2D3748'
                  >
                    {moment(bookingDetail?.created_at).format(
                      'DD/MM/YYYY HH:mm:ss'
                    )}
                  </Text>
                </Flex>
                <Flex align='center' gap={2} mb={2}>
                  <Text fontSize='base' color='#718096' minW={{ base: '100px', lg: '110px' }}>
                    By:
                  </Text>
                  <Text
                    fontSize='base'
                    fontWeight='bold'
                    color='#2D3748'
                  >
                    {bookingDetail?.created_by &&
                    bookingDetail?.created_by.length > 0
                      ? bookingDetail?.created_by
                      : 'guestbooking'}
                  </Text>
                </Flex>
              </Flex>
              <Flex>
                <Flex direction='column' align='center'>
                  <QRCode
                    value={bookingDetail?.code}
                    size={64}
                    level={'M'}
                    bgColor={'#ffffff'}
                    fgColor={'#000000'}
                  />
                  {bookingDetail?.status !== Cancel && (
                    <Select
                      textAlign='center'
                      value={modeViewETicket}
                      onChange={handleLanguageChange}
                      textDecoration='underline'
                      fontWeight='bold'
                      fontSize='base'
                      color='var(--chakra-colors-blue-500)'
                      variant='unstyled'
                      placeholder='View File'
                      style={{
                        paddingRight: 6,
                        textAlignLast: 'center',
                        MozTextAlignLast: 'center',
                        appearance: 'none',
                        WebkitAppearance: 'none'
                       }}
                    >
                      {bookingDetail?.payment_type !== Unpaid && (
                        <>
                          <option value='en_B2C'>E-ticket B2C English</option>
                          <option value='vi_B2C'>
                            E-ticket B2C Tiếng Việt
                          </option>
                          <option value='en_B2B'>E-ticket B2B English</option>
                          <option value='vi_B2B'>
                            E-ticket B2B Tiếng Việt
                          </option>
                        </>
                      )}

                      <option value='en_Information'>
                        Booking information English
                      </option>
                      <option value='vi_Information'>
                        Booking information Tiếng Việt
                      </option>
                      {hasPrintedSeat() && (
                        <>
                          <option value='en_TheaterPass'>
                            Theater Pass English
                          </option>
                          <option value='vi_TheaterPass'>
                            Theater Pass Tiếng Việt
                          </option>
                        </>
                      )}
                    </Select>
                  )}
                </Flex>
                {bookingDetail?.status == Cancel && (
                  <Flex>
                    <Image
                      style={{ height: '64px' }}
                      src={cancelLogo}
                      alt='logo'
                    />
                  </Flex>
                )}
              </Flex>
              <Flex ml={4}>
                <Stack direction='row' alignItems='center' spacing={4}>
                  {checkForbidden(45) &&
                    bookingDetail?.status !== Cancel &&
                    parseInt(bookingDetail?.payment_type) !== Unpaid && (
                      <Tooltip
                        hasArrow
                        label='Print Theater Pass'
                        bg='gray.400'
                      >
                        <Button
                          className='icon-btn-no-shadow'
                          size='m'
                          colorScheme='blue'
                          p='0px'
                          variant='no-effects'
                          onClick={() => {
                            goToPrintTheaterPass();
                          }}
                        >
                          <Flex
                            color={textColorIcon}
                            cursor='pointer'
                            align='center'
                            p='0px'
                          >
                            <Icon w={6} h={6} as={IoPrintOutline} me='0px' />
                          </Flex>
                        </Button>
                      </Tooltip>
                    )}
                  {checkForbidden(45) && bookingDetail?.status !== Cancel && (
                    <Tooltip hasArrow label='Send Email' bg='gray.400'>
                      <Button
                        className='icon-btn-no-shadow'
                        size='m'
                        colorScheme='blue'
                        p='0px'
                        variant='no-effects'
                        onClick={() => {
                          onOpenSendETicketModal();
                        }}
                      >
                        <Flex
                          color={textColorIcon}
                          cursor='pointer'
                          align='center'
                          p='0px'
                        >
                          <Icon w={6} h={6} as={IoMail} me='0px' />
                        </Flex>
                      </Button>
                    </Tooltip>
                  )}
                  {checkForbidden(8) &&
                    bookingDetail?.status != BookingStatusCancel && (
                      <Tooltip hasArrow label='Cancel Booking' bg='gray.400'>
                        <Button
                          className='icon-btn-no-shadow'
                          size='m'
                          colorScheme='blue'
                          p='0px'
                          variant='no-effects'
                          isLoading={isCheckingPendingTransaction}
                          onClick={async () => {
                            setIsCheckingPendingTransaction(true);
                            try {
                              const res = await bookingActions.checkPendingTransaction(booking_id);
                              if (res.data?.data?.has_pending_transaction) {
                                onOpenPendingTransactionModal();
                              } else {
                                onOpenCancelBookingModal();
                              }
                            } catch {
                              onOpenCancelBookingModal();
                            } finally {
                              setIsCheckingPendingTransaction(false);
                            }
                          }}
                        >
                          <Flex
                            color={textColorIcon}
                            cursor='pointer'
                            align='center'
                            p='0px'
                          >
                            <Icon w={6} h={6} as={MdOutlineCancel} me='0px' />
                          </Flex>
                        </Button>
                      </Tooltip>
                    )}
                  {checkForbidden(7) && isDisplayCloneIcon && (
                    <Tooltip hasArrow label='Clone Booking' bg='gray.400'>
                      <Button
                        className='icon-btn-no-shadow'
                        size='m'
                        colorScheme='blue'
                        p='0px'
                        variant='no-effects'
                        onClick={() => {
                          cloneBooking();
                        }}
                      >
                        <Flex
                          color={textColorIcon}
                          cursor='pointer'
                          align='center'
                          p='0px'
                        >
                          <Icon w={6} h={6} as={FaRegClone} me='0px' />
                        </Flex>
                      </Button>
                    </Tooltip>
                  )}
                  {checkForbidden(18) &&
                    bookingDetail?.status !== Cancel &&
                    bookingDetail?.payment_type !== 3 &&
                    bookingDetail?.invoice_status === 0 && (
                      <Tooltip hasArrow label='Publish Invoice' bg='gray.400'>
                        <Button
                          className='icon-btn-no-shadow'
                          size='m'
                          colorScheme='blue'
                          p='0px'
                          variant='no-effects'
                          onClick={() => {
                            onOpenPublishInvoiceModal();
                          }}
                        >
                          <Flex
                            color={textColorIcon}
                            cursor='pointer'
                            align='center'
                            p='0px'
                          >
                            <Icon w={6} h={6} as={MdPublish} me='0px' />
                          </Flex>
                        </Button>
                      </Tooltip>
                    )}
                  {isDisplayExtend && (
                    <Tooltip hasArrow label='Extend Booking' bg='gray.400'>
                      <Button
                        className='icon-btn-no-shadow'
                        size='m'
                        colorScheme='blue'
                        p='0px'
                        variant='no-effects'
                        onClick={() => {
                          onOpenAddExtendBookingModal();
                        }}
                      >
                        <Flex
                          color={textColorIcon}
                          cursor='pointer'
                          align='center'
                          p='0px'
                        >
                          <Icon
                            w={6}
                            h={6}
                            as={AiOutlineClockCircle}
                            me='0px'
                          />
                        </Flex>
                      </Button>
                    </Tooltip>
                  )}
                  <Tooltip hasArrow label='View History' bg='gray.400'>
                    <Button
                      className='icon-btn-no-shadow'
                      size='m'
                      colorScheme='blue'
                      p='0px'
                      variant='no-effects'
                      onClick={() => {
                        showViewHistory();
                      }}
                    >
                      <Flex
                        color={textColorIcon}
                        cursor='pointer'
                        align='center'
                        p='0px'
                      >
                        <Icon w={7} h={7} as={MdHistory} me='0px' />
                      </Flex>
                    </Button>
                  </Tooltip>
                  <Tooltip hasArrow label='View Email History' bg='gray.400'>
                    <Button
                      className='icon-btn-no-shadow'
                      size='m'
                      colorScheme='blue'
                      p='0px'
                      variant='no-effects'
                      onClick={() => {
                        showViewEmailHistory();
                      }}
                    >
                      <Flex
                        cursor='pointer'
                        align='center'
                        p='0px'
                      >
                        <img
                          src='https://d1noej8wkmilgx.cloudfront.net/uploaded/email-history-icon.svg'
                          alt='Email History'
                          style={{ width: '30px', height: '30px' }}
                        />
                      </Flex>
                    </Button>
                  </Tooltip>
                </Stack>
              </Flex>
            </Grid>
          </Box>
          <HSeparator my={4} />
          <Box display={{ base: 'block', lg: 'inline-block' }}>
            <Grid
              templateColumns={{
                base: '1fr',
                lg: 'repeat(2, auto)',
              }}
              columnGap={5}
            >
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Show Name:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {
                    bookingDetail?.show_schedule_detail?.show_schedule?.show
                      .name
                  }
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Venue:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {
                    bookingDetail?.show_schedule_detail?.show_schedule?.venue
                      .name
                  }
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Show Date:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {moment(bookingDetail?.show_schedule_detail?.date).format(
                    'ddd, DD MMM YYYY'
                  )}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Show Time:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.show_schedule_detail?.time.slice(0, -3)}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Address:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {
                    bookingDetail?.show_schedule_detail?.show_schedule?.venue
                      .address
                  }
                </Text>
              </Flex>
              <Flex></Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Adult:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.adult}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Child (5 - 12 ages):
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.child}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Booked Channel:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.unit?.channel?.name}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Booked Unit:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.unit?.name}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2} gridColumn='1 / -1'>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Person In Charge:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.pic_email}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Zone:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.zone?.name}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Floor:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {showTextFloor(bookingDetail?.floor)}
                </Text>
              </Flex>
              <Flex align='center' gap={2} mb={2} gridColumn='1 / -1'>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '100px', lg: '110px' }}
                >
                  Seat No.:
                </Text>
                <Text
                  cursor={'pointer'}
                  maxW='500px'
                  fontWeight='bold'
                  ml={1}
                  fontSize='base'
                  color='var(--chakra-colors-blue-500)'
                >
                  {bookingDetail?.booking_detail
                    ?.map((i) => i.seat)
                    .join(', ') ?? ''}
                </Text>
              </Flex>
            </Grid>
          </Box>
          <HSeparator my={4} />

          <Box overflowX='auto'>
            <Table variant='simple' color={textColor} w='100%'>
              <Thead position='sticky' top={0} bg='white' zIndex={1}>
                <Tr my='.8rem' pl='0px' color='gray.400'>
                  <Th borderColor={borderColor} p='16px 12px'>
                    Channel
                  </Th>
                  <Th borderColor={borderColor} p='16px 12px' whiteSpace='nowrap'>
                    Unit
                  </Th>
                  <Th borderColor={borderColor} p='16px 12px' whiteSpace='nowrap'>
                    Program Applied
                  </Th>
                  <Th borderColor={borderColor} p='16px 12px'>
                    Voucher
                  </Th>
                  <Th borderColor={borderColor} p='16px 12px'>
                    Seat No
                  </Th>
                  <Th borderColor={borderColor} p='16px 12px'>
                    Floor
                  </Th>
                  {bookingDetail?.status !== Cancel &&
                    bookingDetail?.payment_type !== Unpaid && (
                      <Th borderColor={borderColor} p='16px 12px'>
                        Confirmation Code
                      </Th>
                    )}
                  <Th borderColor={borderColor} p='16px 12px'>
                    Official price
                  </Th>
                  <Th borderColor={borderColor} p='16px 12px'>
                    amount
                  </Th>
                  <Th borderColor={borderColor} p='16px 12px'>
                    Seat Status
                  </Th>
                  <Th borderColor={borderColor} p='16px 12px'>
                    View History
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {bookingDetail?.booking_detail?.map((i, index) => (
                  <Tr key={index}>
                    <Td borderColor={borderColor} p='16px 12px'>
                      <Text fontSize='xs' color={textColor}>
                        {i?.channel_name || i?.unit?.channel?.name}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} p='16px 12px' whiteSpace='nowrap'>
                      <Text fontSize='xs' color={textColor}>
                        {i?.unit_name || i?.unit?.name}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} p='16px 12px' whiteSpace='nowrap'>
                      <Text fontSize='xs' color={textColor}>
                        {i.voucher_code_id > 0
                          ? i.voucher_code.voucher.name
                          : i.rateplan_config.rateplan.name}
                        {i.is_child === 0 ? ' - Adult' : ' - Child'}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} p='16px 12px'>
                      <Text fontSize='xs' color={textColor}>
                        {i.voucher_code_id > 0 ? i.voucher_code.code : ''}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} p='16px 12px'>
                      <Text fontSize='xs' color={textColor}>
                        {i.seat}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} p='16px 12px'>
                      <Text fontSize='xs' color={textColor}>
                        {showTextFloor(i.floor)}
                      </Text>
                    </Td>
                    {bookingDetail?.status !== Cancel &&
                      bookingDetail?.payment_type !== Unpaid && (
                        <Td borderColor={borderColor} p='16px 12px'>
                          <Text fontSize='xs' color={textColor}>
                            {seatStatus(i.status) !== 'Unpaid' && i.code}
                          </Text>
                        </Td>
                      )}
                    <Td borderColor={borderColor} p='16px 12px'>
                      <Text fontSize='xs' color={textColor}>
                        {i.official_price.toLocaleString('en-US')}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} p='16px 12px'>
                      <Text fontSize='xs' color={textColor}>
                        {i.amount.toLocaleString('en-US')}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} p='16px 12px'>
                      <Text fontSize='xs' color={textColor}>
                        {seatStatus(i.status)}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} p='16px 12px'>
                      <Tooltip hasArrow label='View History' bg='gray.400'>
                        <Button
                          size='sm'
                          colorScheme='blue'
                          onClick={() => showViewSeatHistory(i.id)}
                        >
                          <Icon as={MdHistory} />
                        </Button>
                      </Tooltip>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        </Box>
        <Grid
          templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }}
          gap='20px'
          mt='20px'
        >
          <Flex direction='column' minW={0}>
            <Flex
              direction={{ base: 'column', sm: 'row' }}
              align={{ base: 'flex-start', sm: 'center' }}
              justify='space-between'
              wrap='wrap'
              gap='10px'
              mb='15px'
            >
              <Text fontSize='base' fontWeight='bold' lineHeight='22px'>
                Payments
              </Text>
              <Flex gap='10px' wrap='wrap'>
                {bookingDetail?.booking_payment?.length > 0 && (
                  <Button
                    onClick={printPaymentReceipt}
                    leftIcon={<IoPrintOutline />}
                    size='xs'
                    colorScheme='blue'
                    variant='outline'
                    isDisabled={selectedPaymentIDs.length === 0}
                    isLoading={isPrintingReceipt}
                  >
                    Print Bill
                    {selectedPaymentIDs.length > 0 && ` (${selectedPaymentIDs.length})`}
                  </Button>
                )}
                {checkForbidden(46) &&
                  isShowPayment &&
                  bookingDetail.status !== 2 && (
                    <Button
                      onClick={() => {
                        setAddPaymentAmount(remainingAmount);
                        onOpenAddPaymentModal();
                        setIsCreatePayment(true);
                      }}
                      leftIcon={<IoAdd />}
                      size='xs'
                      colorScheme='blue'
                      variant='outline'
                    >
                      Add Payment
                    </Button>
                  )}
                {checkForbidden(180) &&
                  isShowPayment &&
                  bookingDetail.status !== 2 &&
                  remainingAmount > 0 && (
                    <Button
                      onClick={() => {
                        setValueCreateTransaction('amount', remainingAmount);
                        onOpenCreateTransactionModal();
                      }}
                      leftIcon={<IoAdd />}
                      size='xs'
                      colorScheme='blue'
                      variant='outline'
                    >
                      Create Transaction
                    </Button>
                  )}
              </Flex>
            </Flex>

            <Tabs colorScheme='blue' variant='enclosed-colored' size='md'>
              <TabList>
                <Tab
                  fontWeight='semibold'
                  _hover={{ bg: 'blue.500', color: 'white' }}
                  _selected={{ fontWeight: 'bold', color: 'white', bg: 'blue.500' }}
                >
                  Payments&nbsp;({bookingDetail?.booking_payment?.length || 0})
                </Tab>
                <Tab
                  fontWeight='semibold'
                  _hover={{ bg: 'blue.500', color: 'white' }}
                  _selected={{ fontWeight: 'bold', color: 'white', bg: 'blue.500' }}
                >
                  Transactions&nbsp;({bookingDetail?.booking_transaction?.length || 0})
                </Tab>
              </TabList>
              <TabPanels>
                <TabPanel px='0'>
                  <Box border='1px solid #D9D9D9'>
                    <Box overflowX='auto'>
                      <Table
                        variant='simple'
                        color={textColor}
                        sx={{
                          tableLayout: 'auto !important',
                          width: 'auto !important',
                          minWidth: '100% !important',
                        }}
                      >
                        <Thead>
                          <Tr>
                            <Th borderColor={borderColor} width='40px'>
                              <Checkbox
                                isChecked={isAllPaymentsSelected}
                                isIndeterminate={
                                  selectedPaymentIDs.length > 0 && !isAllPaymentsSelected
                                }
                                onChange={(e) =>
                                  setSelectedPaymentIDs(e.target.checked ? allPaymentIDs : [])
                                }
                              />
                            </Th>
                            <Th borderColor={borderColor} whiteSpace='nowrap'>#</Th>
                            <Th borderColor={borderColor} whiteSpace='nowrap'>Payment</Th>
                            <Th borderColor={borderColor} whiteSpace='nowrap'>Created</Th>
                            <Th borderColor={borderColor} whiteSpace='nowrap'>Printed</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {bookingDetail?.booking_payment?.length > 0 ? (
                            visiblePayments.map((i) => (
                                <Tr key={i.__no}>
                                  <Td borderColor={borderColor}>
                                    <Checkbox
                                      isDisabled={i.id == null}
                                      isChecked={i.id != null && selectedPaymentIDs.includes(i.id)}
                                      onChange={() => togglePaymentSelected(i.id)}
                                    />
                                  </Td>
                                  <Td borderColor={borderColor} whiteSpace='nowrap'>#{i.__no}</Td>
                                  <Td borderColor={borderColor} whiteSpace='nowrap'>
                                    <Text fontWeight='bold'>
                                      {i.amount.toLocaleString('en-US')} VND
                                    </Text>
                                    <Text fontSize='xs' color='gray.500'>
                                      {paymentMethodText(i.payment_method)} · Paid
                                    </Text>
                                    {i.received_amount > 0 && (
                                      <Text fontSize='xs' color='gray.500'>
                                        Received {i.received_amount.toLocaleString('en-US')} · Change{' '}
                                        {(i.received_amount - i.amount).toLocaleString('en-US')}
                                      </Text>
                                    )}
                                  </Td>
                                  <Td borderColor={borderColor} whiteSpace='nowrap'>
                                    <Text>
                                      {i.created_by.length === 0
                                        ? 'guestbooking'
                                        : i.created_by}
                                    </Text>
                                    <Text fontSize='xs' color='gray.500'>
                                      {moment(i?.created_at).format(
                                        'DD/MM/YYYY HH:mm:ss'
                                      )}
                                    </Text>
                                  </Td>
                                  <Td borderColor={borderColor} whiteSpace='nowrap'>
                                    <Flex align='center' gap='8px'>
                                      <Text>{i.print_count || 0}</Text>
                                      <Tooltip hasArrow label='View History' bg='gray.400'>
                                        <Button
                                          size='xs'
                                          colorScheme='blue'
                                          isDisabled={i.id == null}
                                          onClick={() => showViewPaymentHistory(i.id)}
                                        >
                                          <Icon as={MdHistory} />
                                        </Button>
                                      </Tooltip>
                                    </Flex>
                                  </Td>
                                </Tr>
                              ))
                          ) : (
                            <Tr>
                              <Td
                                colSpan={5}
                                textAlign='center'
                                color='red'
                                fontWeight='bold'
                              >
                                No Payment
                              </Td>
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                    </Box>
                    {bookingDetail?.booking_payment?.length > PAYMENTS_TABLE_ROW_LIMIT && (
                      <Box borderTop='1px solid #D9D9D9' px='16px' py='8px'>
                        <Button
                          onClick={() => setIsPaymentsTableExpanded((v) => !v)}
                          size='xs'
                          variant='link'
                          colorScheme='blue'
                        >
                          {isPaymentsTableExpanded
                            ? 'View less'
                            : `View more (${bookingDetail.booking_payment.length - PAYMENTS_TABLE_ROW_LIMIT})`}
                        </Button>
                      </Box>
                    )}
                  </Box>
                </TabPanel>
                <TabPanel px='0'>
                  <Box border='1px solid #D9D9D9'>
                    <Box overflowX='auto'>
                    <Table
                      variant='simple'
                      color={textColor}
                      sx={{
                        tableLayout: 'auto !important',
                        width: 'auto !important',
                        minWidth: '100% !important',
                      }}
                    >
                      <Thead>
                        <Tr>
                          <Th borderColor={borderColor} width='40px' />
                          <Th borderColor={borderColor} whiteSpace='nowrap'>#</Th>
                          <Th borderColor={borderColor} whiteSpace='nowrap'>Amount</Th>
                          <Th borderColor={borderColor} whiteSpace='nowrap'>Gateway</Th>
                          <Th borderColor={borderColor} whiteSpace='nowrap'>Status</Th>
                          <Th borderColor={borderColor} whiteSpace='nowrap'>Response</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {bookingDetail?.booking_transaction?.length > 0 ? (
                          visibleTransactions.map((i) => {
                              const isRowExpanded = !!expandedTransactionRows[i.__no];
                              return (
                                <React.Fragment key={i.__no}>
                                  <Tr>
                                    <Td borderColor={borderColor} p='4px'>
                                      <IconButton
                                        aria-label='Toggle transaction details'
                                        icon={<ChevronRightIcon />}
                                        size='xs'
                                        variant='ghost'
                                        transform={isRowExpanded ? 'rotate(90deg)' : undefined}
                                        transition='transform 0.15s'
                                        onClick={() =>
                                          setExpandedTransactionRows((prev) => ({
                                            ...prev,
                                            [i.__no]: !prev[i.__no],
                                          }))
                                        }
                                      />
                                    </Td>
                                    <Td borderColor={borderColor} whiteSpace='nowrap'>#{i.__no}</Td>
                                    <Td borderColor={borderColor} whiteSpace='nowrap' fontWeight='bold'>
                                      {i.amount?.toLocaleString('en-US')} VND
                                    </Td>
                                    <Td borderColor={borderColor} whiteSpace='nowrap'>{i.payment_gateway_name}</Td>
                                    <Td borderColor={borderColor} whiteSpace='nowrap'>{i.payment_status_name}</Td>
                                    <Td borderColor={borderColor} whiteSpace='nowrap'>{i.response_message}</Td>
                                  </Tr>
                                  {isRowExpanded && (
                                    <Tr>
                                      <Td borderColor={borderColor} colSpan={6} bg='gray.50'>
                                        <Flex direction='column' gap='6px' py='4px'>
                                          <Flex justify='space-between'>
                                            <Text fontSize='sm' color='gray.500'>
                                              Transaction Code:
                                            </Text>
                                            <Text fontSize='sm' fontWeight='bold'>
                                              {i.transaction_code}
                                            </Text>
                                          </Flex>
                                          <Flex justify='space-between'>
                                            <Text fontSize='sm' color='gray.500'>
                                              Created by:
                                            </Text>
                                            <Text fontSize='sm' fontWeight='bold'>
                                              {i.created_by}
                                            </Text>
                                          </Flex>
                                          <Flex justify='space-between'>
                                            <Text fontSize='sm' color='gray.500'>
                                              Created at:
                                            </Text>
                                            <Text fontSize='sm' fontWeight='bold'>
                                              {moment(i?.created_at).format(
                                                'DD/MM/YYYY HH:mm:ss'
                                              )}
                                            </Text>
                                          </Flex>
                                          <Flex justify='space-between'>
                                            <Text fontSize='sm' color='gray.500'>
                                              Updated at:
                                            </Text>
                                            <Text fontSize='sm' fontWeight='bold'>
                                              {moment(i?.updated_at).format(
                                                'DD/MM/YYYY HH:mm:ss'
                                              )}
                                            </Text>
                                          </Flex>
                                        </Flex>
                                      </Td>
                                    </Tr>
                                  )}
                                </React.Fragment>
                              );
                            })
                        ) : (
                          <Tr>
                            <Td
                              colSpan={6}
                              textAlign='center'
                              color='red'
                              fontWeight='bold'
                            >
                              No Transactions
                            </Td>
                          </Tr>
                        )}
                      </Tbody>
                    </Table>
                    </Box>
                    {bookingDetail?.booking_transaction?.length > PAYMENTS_TABLE_ROW_LIMIT && (
                      <Box borderTop='1px solid #D9D9D9' px='16px' py='8px'>
                        <Button
                          onClick={() => setIsTransactionsTableExpanded((v) => !v)}
                          size='xs'
                          variant='link'
                          colorScheme='blue'
                        >
                          {isTransactionsTableExpanded
                            ? 'View less'
                            : `View more (${bookingDetail.booking_transaction.length - PAYMENTS_TABLE_ROW_LIMIT})`}
                        </Button>
                      </Box>
                    )}
                  </Box>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
          <Flex direction='column' minW={0}>
            <Text fontSize='base' fontWeight='bold' lineHeight='22px' mb='15px'>
              Summary
            </Text>
            <Flex border='1px solid #D9D9D9' padding='11px 18px'>
              <Flex direction='column' gap='15px' w='100%'>
                <Flex justify='space-between'>
                  <Text color='black.900'>Total Amount:</Text>
                  <Text fontSize='base' fontWeight='700'>
                    {bookingDetail?.total_amount.toLocaleString('en-US')} VND
                  </Text>
                </Flex>
                {bookingDetail?.payment_type == Unpaid &&
                  bookingDetail?.status == 1 && (
                    <>
                      <Flex justify='space-between'>
                        <Text color='black.900'>Validity:</Text>
                        <Text fontSize='base' fontWeight='700'>
                          {moment(bookingDetail?.expire_at).format(
                            'DD/MM/YYYY HH:mm'
                          )}
                        </Text>
                      </Flex>
                      <Flex justify='space-between'>
                        <Text color='black.900'>Payment Online Validity:</Text>
                        <Text fontSize='base' fontWeight='700'>
                          {moment(bookingDetail?.online_payment_expired_at).format(
                            'DD/MM/YYYY HH:mm'
                          )}
                        </Text>
                      </Flex>
                    </>
                  )}

                <Flex justify='space-between'>
                  <Text color='black.900'>Booking Status:</Text>
                  <Text
                    fontSize='base'
                    fontWeight='700'
                    textTransform='uppercase'
                  >
                    {bookingStatus(bookingDetail?.status)}
                  </Text>
                </Flex>
                {bookingDetail?.payment_type === Unpaid && (
                  <>
                    <Flex justify='space-between'>
                      <Text color='black.900'>Paid:</Text>
                      <Text
                        fontSize='base'
                        fontWeight='700'
                        textTransform='uppercase'
                      >
                        {amountPayment?.toLocaleString('en-US')} VND
                      </Text>
                    </Flex>
                    <Flex justify='space-between'>
                      <Text color='black.900'>Remaining:</Text>
                      <Text
                        fontSize='base'
                        fontWeight='700'
                        textTransform='uppercase'
                      >
                        {remainingAmount?.toLocaleString('en-US')} VND
                      </Text>
                    </Flex>
                  </>
                )}
                <Flex justify='space-between'>
                  <Text color='black.900'>Payment Status:</Text>
                  <Text
                    fontSize='base'
                    fontWeight='700'
                    textTransform='uppercase'
                  >
                    {paymentType(bookingDetail?.payment_type)}
                  </Text>
                </Flex>

                <Flex justify='space-between' mb={2}>
                  <Text color='black.900'>Reference Code:</Text>
                  {editReferenceCode ? (
                    <Flex alignItems='center' gap={2}>
                      <Input
                        bg={'white'}
                        size='sm'
                        maxW={200}
                        fontWeight={'bold'}
                        value={bookerandguestInfo?.reference_code || ''}
                        onChange={(val) =>
                          setBookerandguestInfo((preState) => ({
                            ...preState,
                            reference_code: val.target.value,
                          }))
                        }
                      />
                      <Button
                        size='xs'
                        colorScheme='blue'
                        onClick={() => updateBookingInfoBookerandGuest('reference_code')}
                      >
                        Save
                      </Button>
                      <Button
                        size='xs'
                        variant='ghost'
                        onClick={() => {
                          setEditReferenceCode(false);
                          setBookerandguestInfo((preState) => ({
                            ...preState,
                            reference_code: bookingDetail?.reference_code || '',
                          }));
                        }}
                      >
                        Cancel
                      </Button>
                    </Flex>
                  ) : (
                    <Flex alignItems='center' gap={2}>
                      <Text fontSize='base' fontWeight='700'>
                        {bookerandguestInfo?.reference_code || '-'}
                      </Text>
                      {checkForbidden(9) && (
                        <Flex
                          onClick={() => setEditReferenceCode(true)}
                          cursor='pointer'
                        >
                          <EditIcon />
                        </Flex>
                      )}
                    </Flex>
                  )}
                </Flex>

                <Box width='100%'>
                  <Flex mb={2} alignItems='center'>
                    <Text color='black.900'>Special Request: </Text>
                    <Box ml={3}>
                      {checkForbidden(47) && (
                        <Button
                          onClick={() => {
                            onOpen();
                            setIsCreateSpecialRequest(true);
                          }}
                          leftIcon={<IoAdd />}
                          size='xs'
                          colorScheme='blue'
                          variant='outline'
                        >
                          Add Special Request
                        </Button>
                      )}
                    </Box>
                  </Flex>
                  {bookingDetail?.notes && (
                    <Box
                      textAlign='left'
                      maxHeight='400px'
                      overflowY='auto'
                      fontWeight='bold'
                      sx={{
                        '& .edited-by': {
                          float: 'none !important',
                          fontWeight: 'normal !important',
                        }
                      }}
                      dangerouslySetInnerHTML={{
                        __html: formatNotesHTML(bookingDetail?.notes),
                      }}
                    />
                  )}
                </Box>

                <Flex justify='space-between'>
                  <Text size='sm'>Invoice:</Text>
                  <Text>{bookingDetail?.invoice_response}</Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Grid>
        <Flex direction='column' gap='20px' mt='20px'>
          {bookingDetail?.booking_refund && (
            <Grid templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }} gap='20px'>
            <Flex direction='column' minW={0}>
              <Flex style={{ display: 'flex' }}>
                <Text
                  fontSize='base'
                  fontWeight='bold'
                  lineHeight='22px'
                  mb='15px'
                >
                  Cancel Payment Details
                </Text>
                {bookingDetail?.booking_refund.length > 4 && (
                  <>
                    {showAllRefund ? (
                      <Button
                        onClick={() => {
                          setItemsBookingPaymentRefund(
                            bookingDetail.booking_refund
                          );
                          setShowAllRefund(false);
                        }}
                        leftIcon={<ShowAllIcon />}
                        size='xs'
                        colorScheme='blue'
                        variant='ghost'
                        style={{ width: '120px', marginLeft: '20px' }}
                      >
                        Show all
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          const bookingPaymentSlice = bookingDetail?.booking_refund.slice(
                            0,
                            4
                          );
                          setItemsBookingPaymentRefund(bookingPaymentSlice);
                          setShowAllRefund(true);
                        }}
                        leftIcon={<ShowAllIcon />}
                        size='xs'
                        colorScheme='blue'
                        variant='ghost'
                        style={{ width: '120px', marginLeft: '20px' }}
                      >
                        Show less
                      </Button>
                    )}
                  </>
                )}
              </Flex>
              <Flex border='1px solid #D9D9D9' padding='11px 18px'>
                <Grid templateColumns={{ base: '1fr', md: 'repeat(2, auto)' }} gap='20px' w='100%'>
                  {itemsBookingPaymentRefund &&
                    itemsBookingPaymentRefund.map((i, index) => (
                      <Flex
                        direction='column'
                        key={index}
                        gap='20px'
                        pb={index !== itemsBookingPaymentRefund.length - 1 ? '20px' : 0}
                        borderBottom={
                          index !== itemsBookingPaymentRefund.length - 1
                            ? '1px dashed #D9D9D9'
                            : 'none'
                        }
                      >
                        <Flex justify='space-between'>
                          <Text color='black.900'>Cancelled Type:</Text>
                          <Text fontSize='base' style={{ fontWeight: 'bold' }}>
                            {cancelledTypeText(i?.type)}
                          </Text>
                        </Flex>
                        <Flex justify='space-between'>
                          <Text color='black.900' fontSize={'base'}>
                            Refund/Charge Amount:
                          </Text>
                          <Text fontSize='base' fontWeight={'bold'}>
                            {i?.amount.toLocaleString('en-US')} VND
                          </Text>
                        </Flex>
                        <Flex justify='space-between'>
                          <Text color='black.900' fontSize={'base'}>
                            Cancelled Payment Method:
                          </Text>
                          <Text fontSize='base' fontWeight={'bold'}>
                            {paymentMethodText(i?.refund_method)}
                          </Text>
                        </Flex>
                        <Flex justify='space-between'>
                          <Text color='black.900' fontSize={'base'}>
                            Cancelled Note:
                          </Text>
                          <Text fontSize='base' fontWeight={'bold'}>
                            {i?.notes}
                          </Text>
                        </Flex>
                        <Flex justify='space-between'>
                          <Text color='black.900' fontSize={'base'}>
                            Cancelled by:
                          </Text>
                          <Text fontSize='base' fontWeight={'bold'}>
                            {i?.created_by}
                          </Text>
                        </Flex>
                        <Flex justify='space-between'>
                          <Text color='black.900' fontSize={'base'}>
                            Cancelled date:
                          </Text>
                          <Text fontSize='base' fontWeight={'bold'}>
                            {moment(i?.created_at).format(
                              'DD/MM/YYYY HH:mm:ss'
                            )}
                          </Text>
                        </Flex>
                      </Flex>
                    ))}
                </Grid>
              </Flex>
            </Flex>
            </Grid>
          )}
          <Grid templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }} gap='20px'>
          <Flex direction='column' minW={0}>
            <Flex align='center' mb='15px'>
              <Text fontSize='base' fontWeight='bold' lineHeight='22px'>
                Booker Information
              </Text>
              {checkForbidden(9) && (
                <Flex
                  align='center'
                  ml='20px'
                  onClick={() => setEditBooker(!editBooker)}
                  cursor='pointer'
                >
                  <EditIcon />
                  <Text ml={1} fontWeight='bold'>
                    EDIT
                  </Text>
                </Flex>
              )}
            </Flex>
            <Flex
              p='10px 20px'
              bg='#F8F9FA'
              borderRadius='12px'
              direction='column'
              gap='15px'
            >
              {editBooker ? (
                <>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Full Name:</Text>
                    <Input
                      bg={'white'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      fontWeight={'bold'}
                      value={bookerandguestInfo.booker_name}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          booker_name: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Phone:</Text>
                    <Input
                      fontWeight={'bold'}
                      bg={'white'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.booker_phone}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          booker_phone: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Email:</Text>
                    <FormControl w={{ base: 'full', sm: '280px' }} isInvalid={errorMessage}>
                      <Input
                        fontWeight={'bold'}
                        bg={'white'}
                        size='sm'
                        value={bookerandguestInfo.booker_email}
                        onChange={(val) => {
                          if (!validateEmail(val.target.value)) {
                            setErrorMessage('Invalid email address.');
                          } else {
                            setErrorMessage('');
                          }
                          setBookerandguestInfo((preState) => ({
                            ...preState,
                            booker_email: val.target.value,
                          }));
                        }}
                      />
                      <FormErrorMessage>{errorMessage}</FormErrorMessage>
                    </FormControl>
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Address 1:</Text>
                    <Input
                      fontWeight={'bold'}
                      bg={'white'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.booker_address}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          booker_address: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Address 2:</Text>
                    <Input
                      bg={'white'}
                      fontWeight={'bold'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.booker_address2}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          booker_address2: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>City/State:</Text>
                    <Input
                      bg={'white'}
                      fontWeight={'bold'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.booker_city}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          booker_city: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Post Code:</Text>
                    <Input
                      bg={'white'}
                      fontWeight={'bold'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.booker_code}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          booker_code: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Country:</Text>
                    <Box w={{ base: 'full', sm: '280px' }}>
                      <ReactSelect
                        options={countries}
                        getOptionLabel={(i) => i.name}
                        getOptionValue={(option) => option.name}
                        chakraStyles={chakraStyles}
                        size='sm'
                        closeMenuOnSelect={true}
                        focusBorderColor='blue.500'
                        className='chakra-select__input'
                        value={{
                          id: bookerandguestInfo.booker_country,
                          name: bookerandguestInfo.booker_country,
                        }}
                        onChange={(val) =>
                          setBookerandguestInfo((preState) => ({
                            ...preState,
                            booker_country: val.name,
                          }))
                        }
                      />
                    </Box>
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Company:</Text>
                    <Input
                      bg={'white'}
                      fontWeight={'bold'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.booker_company}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          booker_company: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex
                    align='center'
                    justify='center'
                    onClick={() => updateBookingInfoBookerandGuest('booker')}
                  >
                    <Button colorScheme='blue'>Update</Button>
                  </Flex>
                </>
              ) : (
                <>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      Full Name:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_name}
                    </Text>
                  </Flex>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      Phone:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_phone}
                    </Text>
                  </Flex>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      Email:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_email}
                    </Text>
                  </Flex>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      Address 1:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_address}
                    </Text>
                  </Flex>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      Address 2:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_address2}
                    </Text>
                  </Flex>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      City/State:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_city}
                    </Text>
                  </Flex>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      Post Code:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_code}
                    </Text>
                  </Flex>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      Country:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_country}
                    </Text>
                  </Flex>
                  <Flex align='flex-start' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                      flexShrink={0}
                    >
                      Company:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base' wordBreak='break-word'>
                      {bookingDetail?.booker_company}
                    </Text>
                  </Flex>
                </>
              )}
            </Flex>
          </Flex>
          <Flex direction='column' minW={0}>
            <Flex align='center' mb='15px'>
              <Text fontSize='base' fontWeight='bold' lineHeight='22px'>
                Audience Information
              </Text>

              <Flex
                align='center'
                ml='20px'
                onClick={() => setEditGuest(!editGuest)}
                cursor='pointer'
              >
                <EditIcon />
                <Text ml={1} fontWeight='bold'>
                  EDIT
                </Text>
              </Flex>
            </Flex>
            <Flex
              p='10px 20px'
              bg='#F8F9FA'
              borderRadius='12px'
              direction='column'
              gap={'15px'}
            >
              {editGuest ? (
                <>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Full Name:</Text>
                    <Input
                      bg={'white'}
                      size='sm'
                      fontWeight={'bold'}
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.guest_name}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          guest_name: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Phone:</Text>
                    <Input
                      bg={'white'}
                      fontWeight={'bold'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.guest_phone}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          guest_phone: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Email:</Text>
                    <Input
                      fontWeight={'bold'}
                      bg={'white'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.guest_email}
                      onChange={(val) => {
                        if (!validateEmail(val.target.value)) {
                          setErrorMessage('Invalid email address.');
                        } else {
                          setErrorMessage('');
                        }
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          guest_email: val.target.value,
                        }));
                      }}
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Address 1:</Text>
                    <Input
                      bg={'white'}
                      size='sm'
                      fontWeight={'bold'}
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.guest_address}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          guest_address: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Address 2:</Text>
                    <Input
                      bg={'white'}
                      size='sm'
                      fontWeight={'bold'}
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.guest_address2}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          guest_address2: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>City/State:</Text>
                    <Input
                      bg={'white'}
                      fontWeight={'bold'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.guest_city}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          guest_city: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Post Code:</Text>
                    <Input
                      bg={'white'}
                      size='sm'
                      fontWeight={'bold'}
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.guest_code}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          guest_code: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Country:</Text>
                    <Box w={{ base: 'full', sm: '280px' }}>
                      <ReactSelect
                        options={countries}
                        getOptionLabel={(i) => i.name}
                        getOptionValue={(option) => option.name}
                        chakraStyles={chakraStyles}
                        size='sm'
                        closeMenuOnSelect={true}
                        focusBorderColor='blue.500'
                        className='chakra-select__input'
                        value={{
                          id: bookerandguestInfo.guest_country,
                          name: bookerandguestInfo.guest_country,
                        }}
                        onChange={(val) =>
                          setBookerandguestInfo((preState) => ({
                            ...preState,
                            guest_country: val.name,
                          }))
                        }
                      />
                    </Box>
                  </Flex>
                  <Flex direction={{ base: 'column', sm: 'row' }} align={{ base: 'flex-start', sm: 'center' }} gap={{ base: 1, sm: '24px' }}>
                    <Text w={{ base: 'auto', sm: '80px' }} flexShrink={0}>Note:</Text>
                    <Input
                      fontWeight={'bold'}
                      bg={'white'}
                      size='sm'
                      w={{ base: 'full', sm: '280px' }}
                      value={bookerandguestInfo.guest_note}
                      onChange={(val) =>
                        setBookerandguestInfo((preState) => ({
                          ...preState,
                          guest_note: val.target.value,
                        }))
                      }
                    />
                  </Flex>
                  <Flex
                    align='center'
                    justify='center'
                    onClick={() => updateBookingInfoBookerandGuest('guest')}
                  >
                    <Button colorScheme='blue'>Update</Button>
                  </Flex>
                </>
              ) : (
                <>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Full Name:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_name}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Phone:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_phone}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Email:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_email}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Address 1:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_address}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Address 2:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_address2}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      City/State:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_city}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Post Code:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_code}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Country:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_country}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Note:{' '}
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingDetail?.guest_note}
                    </Text>
                  </Flex>
                </>
              )}
            </Flex>
          </Flex>
          </Grid>

          {/* How do you know about the show? */}
          <Grid templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }} gap='20px'>
          <Flex direction='column' minW={0}>
            <Flex align='center' mb='15px'>
              <Text fontSize='base' fontWeight='bold' lineHeight='22px'>
                How do you know about the show?
              </Text>
              {checkForbidden(9) && (
                <Flex
                  align='center'
                  ml='20px'
                  onClick={() => setEditDoYouKnow(!editDoYouKnow)}
                  cursor='pointer'
                >
                  <EditIcon />
                  <Text ml={1} fontWeight='bold'>
                    EDIT
                  </Text>
                </Flex>
              )}
            </Flex>
            <Flex
              p='10px 20px'
              bg='#F8F9FA'
              borderRadius='12px'
              direction='column'
              gap='15px'
            >
              {editDoYouKnow ? (
                <>
                  <Flex direction='column' gap='10px'>
                    <Text fontSize='base' color='#718096' mb='8px'>Please select your sources:</Text>
                    <Stack spacing={3} pl='10px'>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('tripAdvisor')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'tripAdvisor';
                          const newSources = sources.includes(key)
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(',')
                          }));
                        }}
                      >
                        Trip Advisor
                      </Checkbox>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('friendsRecommendation')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'friendsRecommendation';
                          const newSources = sources.includes(key)
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(',')
                          }));
                        }}
                      >
                        Friends Recommendation
                      </Checkbox>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('onlineSearch')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'onlineSearch';
                          const newSources = sources.includes(key)
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(',')
                          }));
                        }}
                      >
                        Online Search
                      </Checkbox>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('tourGuideRecommendation')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'tourGuideRecommendation';
                          const newSources = sources.includes(key)
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(',')
                          }));
                        }}
                      >
                        Tour Guide's Recommendation
                      </Checkbox>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('travelAgency')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'travelAgency';
                          const newSources = sources.includes(key)
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(',')
                          }));
                        }}
                      >
                        Travel Agency
                      </Checkbox>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('onlineTravel')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'onlineTravel';
                          const newSources = sources.includes(key)
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(',')
                          }));
                        }}
                      >
                        Online travel websites / communities
                      </Checkbox>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('luneProductionFacebook')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'luneProductionFacebook';
                          const newSources = sources.includes(key)
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(',')
                          }));
                        }}
                      >
                        Lune Production's Facebook Page
                      </Checkbox>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('newspapersMagazines')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'newspapersMagazines';
                          const newSources = sources.includes(key)
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(',')
                          }));
                        }}
                      >
                        Newspapers / Magazines
                      </Checkbox>
                      <Checkbox
                        isChecked={bookerandguestInfo.doyouknow?.includes('others')}
                        onChange={() => {
                          const sources = bookerandguestInfo.doyouknow.split(',').filter(s => s.trim());
                          const key = 'others';
                          const isRemoving = sources.includes(key);
                          const newSources = isRemoving
                            ? sources.filter(s => s !== key)
                            : [...sources, key];
                          setBookerandguestInfo(prev => ({
                            ...prev,
                            doyouknow: newSources.join(','),
                            doyouknow_other: isRemoving ? '' : prev.doyouknow_other
                          }));
                        }}
                      >
                        Others (please specify)
                      </Checkbox>
                    </Stack>
                  </Flex>
                  {bookerandguestInfo.doyouknow?.includes('others') && (
                    <Flex direction='column' gap='5px'>
                      <Text fontSize='base' color='#718096'>Other Details (max 255 characters):</Text>
                      <Input
                        bg='white'
                        size='sm'
                        maxLength={255}
                        value={bookerandguestInfo.doyouknow_other || ''}
                        onChange={(e) =>
                          setBookerandguestInfo((prev) => ({
                            ...prev,
                            doyouknow_other: e.target.value,
                          }))
                        }
                        placeholder='Please specify...'
                      />
                    </Flex>
                  )}
                  <Flex
                    align='center'
                    justify='center'
                    onClick={() => updateBookingInfoBookerandGuest('doyouknow')}
                  >
                    <Button colorScheme='blue'>Update</Button>
                  </Flex>
                </>
              ) : (
                <>
                  <Flex direction='column'>
                    <Text fontSize='base' color='#718096' mb='8px'>Sources:</Text>
                    <Flex direction='column' gap='5px' pl='10px'>
                      {(bookingDetail?.doyouknow
                        ? showTextDoYouKnow(bookingDetail.doyouknow, true)
                        : []).map((source, index) => (
                        <Text key={index} fontSize='base' fontWeight='bold'>
                          • {source}
                        </Text>
                      ))}
                    </Flex>
                  </Flex>
                  <Flex direction='column'>
                    <Text fontSize='base' color='#718096' mb='8px'>Other Details:</Text>
                    <Text fontSize='base' pl='10px' fontWeight='bold'>
                      {bookingDetail?.doyouknow_other || ''}
                    </Text>
                  </Flex>
                </>
              )}
            </Flex>
          </Flex>

          {/* Invoice Information */}
          <Flex direction='column' minW={0}>
            <Text fontSize='base' fontWeight='bold' lineHeight='22px' mb='15px'>
              Invoice Information
            </Text>
            <Flex
              p='10px 20px'
              bg='#F8F9FA'
              borderRadius='12px'
              direction='column'
              gap='15px'
            >
              <Flex align='center' gap={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '120px', lg: '140px' }}
                >
                  Company Name:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.booking_invoice?.company_name || ''}
                </Text>
              </Flex>
              <Flex align='center' gap={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '120px', lg: '140px' }}
                >
                  Tax Code:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.booking_invoice?.tax_code || ''}
                </Text>
              </Flex>
              <Flex align='center' gap={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '120px', lg: '140px' }}
                >
                  Company Address:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.booking_invoice?.company_address || ''}
                </Text>
              </Flex>
              <Flex align='center' gap={2}>
                <Text
                  fontSize='base'
                  color='#718096'
                  minW={{ base: '120px', lg: '140px' }}
                >
                  Email:
                </Text>
                <Text fontWeight='bold' fontSize='base'>
                  {bookingDetail?.booking_invoice?.email || ''}
                </Text>
              </Flex>
            </Flex>
          </Flex>
          </Grid>
        </Flex>
      </CardBody>
      <CustomerDisplayPreview />
    </Card>
  );
}
